<template>
    <div class="big-box">
        <div style="width:100%;height:4.75%;position: relative;display:flex;">
            <div style="width:30%;height:100%;padding-left:20rem;display:flex;justify-content: flex-start;align-content: center;align-items: center;">
                <img @click="goBack" src="../../assets/image/back1.png" style="width:3vh;position: relative;left: -1vh;cursor: pointer;" />
                <span style="font-size: 30rem;">{{curTime}}</span>
            </div>
            <div class="nowrap" style="width:40%;height:100%;font-size:120rem;text-align: center;">
                {{proInfo.name}}智慧工地数据展示平台
            </div>
            <div style="width:30%;height:100%;"></div>
        </div>
        <!-- 第一列 -->
        <div class="list-group-box1">
            <draggable class="list-group" tag="ul" :list="list0" group="project" @change="log" style="padding:0;">
                <li class="list-group-item" v-for="(element, index) in list0" :key="index">
                    <div v-if="element.index=='1' && element.show" class="item-div" style="padding: 0 20rem 20rem;" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 劳务统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在职总数</p>
                            <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在场人数</p>
                            <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在场率</p>
                        </div>
                        <div style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                            <p style="width:33%;padding:0 18rem;">
                                <img src="../../assets/image/visual/li0.png" style="width:130rem;height:90rem;position: absolute;left: calc( 50% - 65rem );top: -20rem;" />
                                <span class="nowrap" style="display: inline-block;width: 100%;">{{person.zaiZhiCount}}</span>
                            </p>
                            <p style="width:33%;padding:0 18rem;">
                                <img src="../../assets/image/visual/li0.png" style="width:130rem;height:90rem;position: absolute;left: calc( 50% - 65rem );top: -20rem;" />
                                <span class="nowrap" style="display: inline-block;width: 100%;">{{person.zaiChangCount}}</span>
                            </p>
                            <p style="width:33%;padding:0 18rem;">
                                <img src="../../assets/image/visual/li0.png" style="width:130rem;height:90rem;position: absolute;left: calc( 50% - 65rem );top: -20rem;" />
                                <span class="nowrap" style="display: inline-block;width: 100%;">{{person.bilv}}%</span>
                            </p>
                        </div>
                    </div>
                    <div v-if="element.index=='2' && element.show" class="item-div" style="padding: 0 20rem 20rem;" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:400rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 58rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 58rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">累计</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.cq}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.cqRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='3' && element.show" class="item-div" style="padding: 0 20rem;" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:25%;position: relative;text-align: center;transform: scale(0.9);">在职人数</p>
                            <p style="width:25%;position: relative;text-align: center;transform: scale(0.9);">在场人数</p>
                            <p style="width:25%;position: relative;text-align: center;transform: scale(0.9);">出勤人数</p>
                        </div>
                        <div style="width:100%;height:620rem;position: relative;overflow: hidden;">
                            <ul>
                                <li v-for="(item,index) in keyList" :key="index" style="height:120rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.lable}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.count}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.present}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.attend}}</span>
                                    </p>
                                </li>
                            </ul>
                            <div style="width:100%;height:120rem;position: relative;display:flex;align-items: center;">
                                <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">
                                    累计
                                </p>
                                <p style="width:25%;position: relative;text-align: center;">
                                    <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                    <span class="nowrap" style="display: inline-block;width: 100%;">{{keyAll.count}}</span>
                                </p>
                                <p style="width:25%;position: relative;text-align: center;">
                                    <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                    <span class="nowrap" style="display: inline-block;width: 100%;">{{keyAll.present}}</span>
                                </p>
                                <p style="width:25%;position: relative;text-align: center;">
                                    <img src="../../assets/image/visual/li0.png" style="width:120rem;height:70rem;position: absolute;left: calc( 50% - 62rem );top: -10rem;" />
                                    <span class="nowrap" style="display: inline-block;width: 100%;">{{keyAll.attend}}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='4' && element.show" class="item-div" style="padding: 0 20rem;" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:80rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">人员动态</span>
                            </p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;padding:0 10rem;align-items: center;">
                            <p style="font-size:18rem;color:#fff;padding-left:10rem;">累计采集{{syn.zs}}人</p>
                            <p style="font-size:18rem;color:#fff;padding-left:40rem;">实名占比{{syn.smRate}}</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;display:flex;">
                            <div style="width: 50%;height: 100%;">
                                <div id="myChart1" style="width:100%; height:100%"></div>
                            </div>
                            <div class="first-gress-con" style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">在职人员({{syn.zz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未在职人员({{syn.wzz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未实名人员({{syn.lz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#E66E3A"></el-progress></p>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='6' && element.show" class="item-div" style="padding: 0 20rem;" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:160rem;position: relative;display:flex;justify-content: space-between;padding:0 0 0 36rem;flex-wrap:wrap;">
                            <p style="width:100%;text-align:left;">
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">合同信息</span>
                            </p>
                            <p style="color:#fff;font-size:12rem;">应签{{agreeNum.yqht}}人</p>
                            <p style="color:#fff;font-size:12rem;">已网签{{agreeNum.ywq}}人</p>
                            <p style="color:#fff;font-size:12rem;">未网签{{agreeNum.wxq}}人</p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">入职时间</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">合同状态</p>
                        </div>
                        <div style="width:100%;height:1170rem;position: relative;overflow: hidden;">
                            <ul :class="{anim1:animate1==true}">
                                <li v-for="(item,index) in tableAgree" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.create_date}}</span>
                                    </p>
                                    <p style="width:25%;padding:0;">
                                        <span v-if="item.status=='已网签'" style="display: inline-block;width: 100%;color:#FFFFFF;">已网签</span>
                                        <span v-else style="display: inline-block;width: 100%;color:#E66E3A;">未网签</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- 第一列 - 替补（list1） -->
                    <!-- <div v-if="element.index=='7' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')" >
                        <p class="item-title"> 产值进度 </p>
                        <div style="width:100%;height:500rem;position: relative;display:flex;">
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计提报产值</p>
                                <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                    229
                                    <img src="../../assets/image/visual/val1.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                </div>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计审定产值</p>
                                <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                    229
                                    <img src="../../assets/image/visual/val2.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                </div>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计合同额</p>
                                <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                    229
                                    <img src="../../assets/image/visual/val3.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='8' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 产值进度明细 </p>
                        <div style="width:100%;height:900rem;position: relative;overflow: hidden;">
                            <ul :class="{anim2:animate2==true}">
                                <li v-for="(item,index) in progressList" :key="index" style="height:300rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;flex-wrap:wrap;">
                                    <p style="width:100%;padding:0 18rem;height:80rem;padding-top: 15rem;">
                                        <span class="nowrap" style="display: inline-block;width: 50%;text-align: left;">{{item.projectName}}</span>
                                        <span class="nowrap" style="display: inline-block;width: 50%;">合同额:{{item.price}}万</span>
                                    </p>
                                    <div style="width:100%;padding:0 18rem;display:flex;align-items: center;height:80rem;justify-content: center;">
                                        <span style="margin-right:10rem;">本次审定</span>
                                        <p style="width: 50%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(item.pay.apprlv)>100?100:parseFloat(item.pay.apprlv)" :stroke-width="20"></el-progress></p>
                                        <span>{{item.pay.apprMoney}}万</span>
                                    </div>
                                    <div style="width:100%;padding:0 18rem;display:flex;align-items: center;height:80rem;justify-content: center;">
                                        <span style="margin-right:10rem;">累计审定</span>
                                        <p style="width: 50%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(item.pay.totalLv)>100?100:parseFloat(item.pay.totalLv)" color="#9486FF" :stroke-width="20"></el-progress></p>
                                        <span>{{item.pay.total0}}万</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='9' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 关键节点进度 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:35%;position: relative;text-align: center;padding:0 18rem;">正常项目数</p>
                            <p style="width:35%;position: relative;text-align: center;padding:0 18rem;">滞后项目数</p>
                        </div>
                        <div style="width:100%;height:600rem;position: relative;overflow: hidden;">
                            <ul :class="{anim3:animate3==true}">
                                <li v-for="(item,index) in nodeList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.nodeTypeName}}</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:52rem;position: absolute;left: calc( 50% - 43rem );top: 0rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.normalCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:52rem;position: absolute;left: calc( 50% - 43rem );top: 0rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.delayCount}}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='10' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 质量安全 </p>
                        <div style="width:100%;height:550rem;position: relative;display:flex;">
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                <div id="safeEnt1" style="width:100%; height:260rem;position: relative;"></div>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#9285F7;"></span>问题已处理</p>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                <div id="safeEnt2" style="width:100%; height:260rem;position: relative;"></div>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#15D2B1;"></span>问题已处理</p>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                <div id="safeEnt3" style="width:100%; height:260rem;position: relative;"></div>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#2299F1;"></span>问题已处理</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='11' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 短信预警 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">事项</p>
                            <p style="width:60%;position: relative;text-align: center;padding:0 18rem;">内容</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:40%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"></span>
                                    </p>
                                    <p style="width:60%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"></span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                    <!-- 第一列 - 替补（list3） -->
                    <!-- <div v-if="element.index=='13' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> {{project.name}}—质量安全 </p>
                        <div style="width:100%;height:1200rem;position: relative;display:flex;">
                            <div style="width:100%;height:50%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;padding-bottom: 20rem;position: relative;height:200rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">项目检查  {{safePro.projectAllQsCount}}次</p>
                                <div style="width:100%;height:400rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                    <div id="safe1" style="width:100%; height:360rem;"></div>
                                </div>
                            </div>
                            <div style="width:100%;height:50%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;padding-bottom: 20rem;position: relative;height:200rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">公司检查  {{safePro.entAllQsCount}}次</p>
                                <div style="width:100%;height:400rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                    <div id="safe2" style="width:100%; height:360rem;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='15' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 塔吊安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">超重预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate4==true}">
                                <li v-for="(item,index) in towerEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                    </p>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='16' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 卸料平台安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">超重预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate5==true}">
                                <li v-for="(item,index) in unloadEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='17' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 高支模安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">压力预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate6==true}">
                                <li v-for="(item,index) in highEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.pressure}}次</span>
                                    </p>
                                </li>
                                
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='18' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 升降机安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">超重预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate7==true}">
                                <li v-for="(item,index) in eleEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='19' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 混凝土测温安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">测温预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate8==true}">
                                <li v-for="(item,index) in mixedEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.warning}}次</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </li>
            </draggable>
        </div>
        
        <!-- 第二列 -->
        <div class="list-group-box1" style="margin:0;">
            <draggable class="list-group" tag="ul" :list="list1" group="project" @change="log" style="background: transparent;padding:0;">
                <li class="list-group-item" v-for="(element, index) in list1" :key="index">
                    <!--第二列- 替补（list0) -->
                    <!-- <div v-if="element.index=='1' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 劳务统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在职总数</p>
                            <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在场人数</p>
                            <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在场率</p>
                        </div>
                        <div style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                            <p style="width:33%;padding:0 18rem;">
                                <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                <span class="nowrap" style="display: inline-block;width: 100%;">{{person.zaiZhiCount}}</span>
                            </p>
                            <p style="width:33%;padding:0 18rem;">
                                <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                <span class="nowrap" style="display: inline-block;width: 100%;">{{person.zaiChangCount}}</span>
                            </p>
                            <p style="width:33%;padding:0 18rem;">
                                <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                <span class="nowrap" style="display: inline-block;width: 100%;">{{person.bilv}}%</span>
                            </p>
                        </div>
                    </div>
                    <div v-if="element.index=='2' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:60rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">今日出勤</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{attend.allTeamsCount}}</span>
                            </p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                        </div>
                        <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersRate}}%</span>
                                    </p>
                                </li>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialRate}}%</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='3' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:80rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">关键岗位履责</span>
                                <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">100</span>
                            </p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:25%;position: relative;text-align: center;">在职人数</p>
                            <p style="width:25%;position: relative;text-align: center;">在场人数</p>
                            <p style="width:25%;position: relative;text-align: center;">出勤人数</p>
                        </div>
                        <div style="width:100%;height:400rem;position: relative;overflow: hidden;">
                            <ul>
                                <li v-for="(item,index) in keyList" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.lable}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -4rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.count}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -4rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.present}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -4rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.attend}}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='4' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:80rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">人员动态</span>
                            </p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;padding:0 36rem;align-items: center;">
                            <p style="font-size:18rem;color:#fff;padding-left:30rem;">累计采集{{syn.zs}}人</p>
                            <p style="font-size:18rem;color:#fff;padding-left:50rem;">实名占比{{syn.smRate}}</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;display:flex;">
                            <div style="width: 50%;height: 100%;">
                                <div id="myChart1" style="width:100%; height:100%"></div>
                            </div>
                            <div class="first-gress-con" style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">在职人员({{syn.zz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未在职人员({{syn.wzz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未实名人员({{syn.lz}}/{{syn.zs}})</p>
                                <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#E66E3A"></el-progress></p>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='5' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:80rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                            <p>
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">安全教育</span>
                            </p>
                        </div>
                        <div style="width:100%;height:420rem;position: relative;overflow: hidden;display:flex;">
                            <div style="width:50%;height:100%;position: relative;">
                                <div id="teach" style="width:100%;height:360rem;position: relative;"></div>
                                <p>未教育人数   <span style="color:#DE2D21;">0</span>人</p>
                            </div>
                            <div style="width:50%;height:100%;position: relative;">
                                <div id="exam" style="width:100%;height:360rem;position: relative;"></div>
                                <p>未考试人数   <span style="color:#DE2D21;">{{edc.nopaper}}</span>人</p>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='6' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <div style="width:100%;height:160rem;position: relative;display:flex;justify-content: space-between;padding:0 0 0 36rem;flex-wrap:wrap;">
                            <p style="width:100%;text-align:left;">
                                <span class="crile"></span>
                                <span style="color:#34ECFF;font-size:22rem;">合同信息</span>
                            </p>
                            <p style="color:#fff;font-size:12rem;">应签{{agreeNum.yqht}}人</p>
                            <p style="color:#fff;font-size:12rem;">已网签{{agreeNum.ywq}}人</p>
                            <p style="color:#fff;font-size:12rem;">未网签{{agreeNum.wxq}}人</p>
                        </div>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                            <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">入职时间</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">合同状态</p>
                        </div>
                        <div style="width:100%;height:640rem;position: relative;overflow: hidden;">
                            <ul :class="{anim1:animate1==true}">
                                <li v-for="(item,index) in tableAgree" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:50%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.create_date}}</span>
                                    </p>
                                    <p style="width:25%;padding:0;">
                                        <span v-if="item.status=='已网签'" style="display: inline-block;width: 100%;color:#FFFFFF;">已网签</span>
                                        <span v-else style="display: inline-block;width: 100%;color:#E66E3A;">未网签</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                    <!-- list1 -->
                    <div v-if="element.index=='7' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 产值进度 </p>
                        <div style="width:100%;height:500rem;position: relative;display:flex;">
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计提报产值</p>
                                <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                    229
                                    <img src="../../assets/image/visual/val1.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                </div>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计审定产值</p>
                                <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                    229
                                    <img src="../../assets/image/visual/val2.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                </div>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计合同额</p>
                                <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                    229
                                    <img src="../../assets/image/visual/val3.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='8' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 产值进度明细 </p>
                        <div style="width:100%;height:1014rem;position: relative;overflow: hidden;">
                            <ul :class="{anim2:animate2==true}">
                                <li v-for="(item,index) in progressList" :key="index" style="height:300rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;flex-wrap:wrap;">
                                    <p style="width:100%;padding:0 18rem;height:80rem;padding-top: 15rem;">
                                        <span class="nowrap" style="display: inline-block;width: 50%;text-align: left;">{{item.projectName}}</span>
                                        <span class="nowrap" style="display: inline-block;width: 50%;">合同额:{{item.price}}万</span>
                                    </p>
                                    <div style="width:100%;padding:0 18rem;display:flex;align-items: center;height:80rem;justify-content: center;">
                                        <span style="margin-right:10rem;">本次审定</span>
                                        <p style="width: 50%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(item.pay.apprlv)>100?100:parseFloat(item.pay.apprlv)" :stroke-width="20"></el-progress></p>
                                        <span>{{item.pay.apprMoney}}万</span>
                                    </div>
                                    <div style="width:100%;padding:0 18rem;display:flex;align-items: center;height:80rem;justify-content: center;">
                                        <span style="margin-right:10rem;">累计审定</span>
                                        <p style="width: 50%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(item.pay.totalLv)>100?100:parseFloat(item.pay.totalLv)" color="#9486FF" :stroke-width="20"></el-progress></p>
                                        <span>{{item.pay.total0}}万</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div v-if="element.index=='9' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 关键节点进度 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                            <p style="width:35%;position: relative;text-align: center;padding:0 18rem;">正常项目数</p>
                            <p style="width:35%;position: relative;text-align: center;padding:0 18rem;">滞后项目数</p>
                        </div>
                        <div style="width:100%;height:600rem;position: relative;overflow: hidden;">
                            <ul :class="{anim3:animate3==true}">
                                <li v-for="(item,index) in nodeList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:30%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.nodeTypeName}}</span>
                                    </p>
                                    <p style="width:40%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:52rem;position: absolute;left: calc( 50% - 43rem );top: 0rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.normalCount}}</span>
                                    </p>
                                    <p style="width:30%;padding:0 18rem;">
                                        <img src="../../assets/image/visual/li0.png" style="width:86rem;height:52rem;position: absolute;left: calc( 50% - 43rem );top: 0rem;" />
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.delayCount}}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='10' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 质量安全 </p>
                        <div style="width:100%;height:616rem;position: relative;display:flex;">
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                <div id="safeEnt1" style="width:100%; height:260rem;position: relative;"></div>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#9285F7;"></span>问题已处理</p>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                <div id="safeEnt2" style="width:100%; height:260rem;position: relative;"></div>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#15D2B1;"></span>问题已处理</p>
                            </div>
                            <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                <div id="safeEnt3" style="width:100%; height:260rem;position: relative;"></div>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#2299F1;"></span>问题已处理</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='11' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 短信预警 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">事项</p>
                            <p style="width:60%;position: relative;text-align: center;padding:0 18rem;">内容</p>
                        </div>
                        <div style="width:100%;height:446rem;position: relative;overflow: hidden;">
                            <ul>
                                <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:40%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"></span>
                                    </p>
                                    <p style="width:60%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"></span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!--第二列- 替补（list3) -->
                    <!-- <div v-if="element.index=='13' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> {{project.name}}—质量安全 </p>
                        <div style="width:100%;height:1200rem;position: relative;display:flex;">
                            <div style="width:100%;height:50%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;padding-bottom: 20rem;position: relative;height:200rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">项目检查  {{safePro.projectAllQsCount}}次</p>
                                <div style="width:100%;height:400rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                    <div id="safe1" style="width:100%; height:360rem;"></div>
                                </div>
                            </div>
                            <div style="width:100%;height:50%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;font-size:20rem;padding-bottom: 20rem;position: relative;height:200rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">公司检查  {{safePro.entAllQsCount}}次</p>
                                <div style="width:100%;height:400rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                    <div id="safe2" style="width:100%; height:360rem;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='15' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 塔吊安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">超重预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate4==true}">
                                <li v-for="(item,index) in towerEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                    </p>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='16' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 卸料平台安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">超重预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate5==true}">
                                <li v-for="(item,index) in unloadEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="element.index=='17' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 高支模安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">压力预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate6==true}">
                                <li v-for="(item,index) in highEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.pressure}}次</span>
                                    </p>
                                </li>
                                
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='18' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 升降机安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">超重预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate7==true}">
                                <li v-for="(item,index) in eleEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='19' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 混凝土测温安装统计 </p>
                        <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                            <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                            <p style="width:25%;position: relative;text-align: center;padding:0;">测温预警</p>
                        </div>
                        <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                            <ul :class="{anim4:animate8==true}">
                                <li v-for="(item,index) in mixedEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                    </p>
                                    <p style="width:25%;padding:0 18rem;">
                                        <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.warning}}次</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </li>
            </draggable>
        </div>
        <!-- 总三 -->
        <div style="width:4110rem;height:2935rem; position: relative;display:flex;flex-wrap:wrap;margin:0;">
            <div style="width:3260rem;height:100%;display:flex;flex-wrap:wrap;">
                <div style="width:100%;height:400rem;padding-left:520rem;display: flex;justify-content: space-around;align-content: center;align-items: center;padding-top: 84rem;">
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #0E4CC7 0%, #0374DE 100%, #0374DE 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proNum.all}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">项目总数</p>
                        
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #006FC7 0%, #00B6D5 100%, #00B6D5 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proNum.zj.zjxm}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">在建项目</p>
                    </div>
                    <div style="width:356rem;height:164rem;position: relative;border-radius: 5rem;background: linear-gradient(360deg, #0C47CF 0%, #5D05D6 100%, #5D05D6 100%);display:flex;align-content: center;flex-wrap:wrap;">
                        <p style="width:100%;text-align: center;font-size:36rem;">{{proNum.jg.jgxm}}</p>
                        <p style="width:100%;text-align: center;font-size:36rem;">竣工项目</p>
                    </div>
                </div>
                <!-- 第三列 -->
                <div class="list-group-box1" style="width:1380rem;height:2535rem;margin:0;">
                    <draggable class="list-group" tag="ul" :list="list2" group="project1" @change="log" style="background: transparent;padding:0;">
                        <li class="list-group-item" v-for="(element, index) in list2" :key="index">
                            <div v-if="element.index=='12' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 安康码管控系统 </p>
                                <div style="width:100%;height:900rem;position: relative;display:flex;">
                                    <div style="width:50%;height:100%;position: relative;margin-top:20rem;padding:20rem 20rem 0;display:flex;flex-wrap:wrap;">
                                        <p style="width:100%;height:100rem;position: relative;">
                                            累计统计登记人数  {{anKang.CumulativeDay}}
                                        </p>
                                        <div style="width:100%;height:150rem;position: relative;display:flex;flex-wrap:wrap;justify-content: flex-end;">
                                            <p><span class="crile" style="background:#0CCF93;top: -8rem;"></span>正常绿码  {{anKang.green1}}</p>
                                            <p style="margin-left:20rem;"><span class="crile" style="background:#F8DA2A;top: -8rem;"></span>异常黄码  {{anKang.yellow1}}</p>
                                            <p><span class="crile" style="background:#FB2121;top: -8rem;"></span>历史红码  {{anKang.red1}}</p>
                                        </div>
                                        <div style="width:100%;height:500rem;position: relative;padding-top:10rem;">
                                            <div id="ankang1" style="width:100%; height:100%;"></div>
                                        </div>
                                    </div>
                                    <div style="width:50%;height:100%;position: relative;margin-top:20rem;padding:20rem 20rem 0;display:flex;flex-wrap:wrap;">
                                        <p style="width:100%;height:100rem;position: relative;">
                                            本月统计登记人数  {{anKang.inCumulative}}
                                        </p>
                                        <div style="width:100%;height:150rem;position: relative;display:flex;flex-wrap:wrap;justify-content: flex-end;">
                                            <p><span class="crile" style="background:#0CCF93;top: -8rem;"></span>正常绿码  {{anKang.green2}}</p>
                                            <p style="margin-left:20rem;"><span class="crile" style="background:#F8DA2A;top: -8rem;"></span>异常黄码  {{anKang.yellow2}}</p>
                                            <p><span class="crile" style="background:#FB2121;top: -8rem;"></span>历史红码  {{anKang.red2}}</p>
                                        </div>
                                        <div style="width:100%;height:500rem;position: relative;padding-top:10rem;">
                                            <div id="ankang2" style="width:100%; height:100%;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.index=='25' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title">岗位效能 </p>
                                <div style="width:100%;height:924rem;position: relative;display:flex;flex-wrap:wrap;overflow: hidden;padding-top:40rem;padding-left:20rem;">
                                    <ul :class="{anim9:animate9==true}">
                                        <li v-for="(item,index) in postEffPro" :key="index" style="width:100%;height:240rem;position: relative;margin-bottom: 30rem;display: flex;flex-wrap:wrap;">
                                            <p style="width:100%;height:80rem;position: relative;text-align: center;">{{item.projectName}}</p>
                                            <div style="width:100%;height:160rem;position: relative;display:flex;flex-wrap:wrap;">
                                                <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                                    <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">项目经理</span>
                                                    <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.pmMapsBi}}%</span>
                                                </p>
                                                <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                                    <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">总监代表</span>
                                                    <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.threeMapsBi}}%</span>
                                                </p>
                                                <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                                    <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">总监工程师</span>
                                                    <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.fourMapsBi}}%</span>
                                                </p>
                                                <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                                    <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">检测负责人</span>
                                                    <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.fiveMapsBi}}%</span>
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="element.index=='14' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> <span class="nowrap" style="width: 100%;text-align: center;color:#34ECFF;">{{project.name}}—关键人员人脸考勤</span> </p>
                                <div style="width:100%;height:1394rem;position: relative;display:flex;flex-wrap:wrap;overflow: hidden;padding-top:40rem;padding-left:20rem;align-content: flex-start;padding-bottom: 60rem;">
                                    <div v-for="(item,index) in keyPersonPro" :key="index" style="width:100%;height:300rem;position: relative;margin-bottom: 20rem;display: flex;">
                                        <div style="width:50%;height:100%;background:rgb(134 234 255 / 8%);display:flex;padding:10rem;justify-content: space-between;">
                                            <div style="width:calc( 100% - 200rem );height:100%;position: relative;display:flex;flex-wrap:wrap;justify-content:center;">
                                                <img :src="item.facePhoto" style="max-width:100%;height:180rem;position: relative;" />
                                                <p style="width:100%;text-align: center;">抓拍人脸</p>
                                            </div>
                                            <div style="width:400rem;height:100%;position: relative;">
                                                <el-progress type="circle" :percentage="parseFloat(item.contrast)"></el-progress>
                                            </div>
                                            <div style="width:calc( 100% - 200rem );height:100%;position: relative;display:flex;flex-wrap:wrap;justify-content:center;">
                                                <img :src="item.uploadFile" style="max-width:100%;height:180rem;position: relative;" />
                                                <p style="width:100%;text-align: center;">比对人脸</p>
                                            </div>
                                        </div>
                                        <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: space-around;padding-left:30rem;">
                                            <p style="width:100%;position: relative;text-align: left;">姓名：{{item.personName}}</p>
                                            <p style="width:100%;position: relative;text-align: left;">时间：{{item.updateDate}}</p>
                                            <p style="width:100%;position: relative;text-align: left;display:flex;">安康码：
                                                <img v-if="item.healthLevel=='1'" src="../../assets/image/vis/anKang-gress.png" style="width:120rem;height:120rem;" />
                                                <img v-else-if="item.healthLevel=='2'" src="../../assets/image/vis/anKang-yellow.png" style="width:120rem;height:120rem;" />
                                                <img v-else-if="item.healthLevel=='3'" src="../../assets/image/vis/anKang-red.png" style="width:120rem;height:120rem;" />
                                                <img v-else src="../../assets/image/vis/anKang-no.png" style="width:120rem;height:120rem;" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 第三列-替补（list4） -->
                            <!-- <div v-if="element.index=='20' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> 设备运行监测 </p>
                                <div class="item-div" style="margin-top:64rem;margin-bottom: 64rem;">
                                    <p class="item-head-p" style="height: 100rem;">
                                        <span></span>
                                        <span class="b-line">考勤机</span>
                                        <span class="b-line">塔吊</span>
                                        <span class="b-line">监控</span>
                                        <span class="b-line">升降机</span>
                                        <span class="b-line">高支模</span>
                                        <span class="b-line">卸料</span>
                                        <span class="b-line">螺帽</span>
                                        <span class="b-line">混凝土</span>
                                    </p>
                                    <div class="item1-con" style="padding:0;">
                                        <div class="device-item" style="height: 100rem;">
                                            <p>总数</p>
                                            <p class="b-line" v-for="item in equipStatusList" :key="item.index">{{item.sum}}</p>
                                        </div>
                                        <div class="device-item1" style="height: 100rem;">
                                            <p>在线</p>
                                            <p v-for="item in equipStatusList" :key="item.index">
                                                <img src="../../assets/image/vis/dev-bg.gif" style="width:100rem;height:100rem;" />
                                                <span class="item-span" style="left:0;">{{item.online}}</span>
                                            </p>
                                        </div>
                                        <div class="device-item1" style="height: 100rem;">
                                            <p>离线</p>
                                            <p v-for="item in equipStatusList" :key="item.index">
                                                <img src="../../assets/image/vis/dev-bg1.png" style="width:120rem;height:120rem;" />
                                                <span class="item-span" style="left:0;top:0;">{{item.offline}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="element.index=='21' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> {{project.name}}—塔吊监测 </p>
                                <div style="width:200rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                                    <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                                        <p class="name nowrap" style="width:100%;height:40rem;">{{item.name}}</p>
                                        <p class="state color8" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-if="item.online=='离线'">离线</p>
                                        <p class="state color10" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else-if="item.online=='正常'" >正常</p>
                                        <p class="state color9" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else >{{item.online}}</p>
                                    </div>
                                </div>
                                <div style="width:calc( 100% - 200rem );height:460rem;position: relative;margin-left:180rem;">
                                    <div style="width: 100%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                        <div style="width: 40%;height: 100%;position: relative;padding: 20rem 10rem 10rem;display: flex;flex-wrap: wrap;">
                                            <p style="text-align: center;font-size:20rem;height:80rem;width:100%;top: -3px">实时监控</p>
                                            <div style="width:100%;height:calc( 100% - 30rem );padding:10rem 0;">
                                                <p class="real-data-l-item">
                                                    <span style="">设备幅度</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.radius||0 }}m</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">吊钩高度</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.hight||0 }}m</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">额定吊重</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.ratedWeight||0 }}吨</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">塔吊力矩</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.lijupercent||0 }}N</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">吊重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                    <span style="padding:0 10rem;">{{ towerPart.loadweightr||0 }}吨</span>
                                                </p>
                                                <p class="real-data-l-item">
                                                    <span style="">前倾角&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                    <span style="padding:0 10rem;">{{towerPart.fall||0}}度</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="real-clock" style="width:25%;">
                                            <p style="text-align: left;padding-left:10rem;font-size:20rem;height:80rem;width:100%;text-align: center;">塔吊回转</p>
                                            <div class="real-clock-con" id="wrap">
                                                <ul id="list">
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li>
                                                    <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                                                </ul>
                                                <div class="icon"></div>
                                                <div
                                                    id="clockLine"
                                                    :style="{'-webkit-transform': 'rotate('+towerPart.angle+'deg)'}"
                                                ></div>
                                                <div class="num0">0</div>
                                                <div class="num90">90</div>
                                                <div class="num180">180</div>
                                                <div class="num270">270</div>
                                            </div>
                                        </div>
                                        <div style="width: 33%;height: 100%;position: relative;padding: 10rem;display: flex;flex-wrap: wrap;">
                                            <p style="text-align: center;font-size:20rem;height:80rem;width:100%;">吊钩可视化</p>
                                            <div v-if="cameraData && cameraData.serial" style="width:100%;height:calc( 100% - 30rem );position: relative;">
                                                <iframe width="100%" height="100%" :src='towerVideo' style="border: 0;height: 100%;"></iframe>
                                            </div>
                                            <div v-else style="width:100%;height:calc( 100% - 80rem );position: relative;">
                                                <img src="../../assets/image/monitorBg.png" style="width:100%;height:100%;" />
                                                <p style="width:100%;height:40rem;text-align: center;position: absolute;top:65%;left:0;">暂无视频</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="element.index=='22' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> {{project.name}}—升降机监测 </p>
                                <div style="width:100%;height:520rem;position: relative;display:flex;padding:0 20rem;">
                                    <div style="width:34%;height:100%;display:flex;flex-wrap:wrap;">
                                        <p style="width:100%;height:120rem;position: relative;padding-top: 30rem;display:flex;justify-content:space-between;align-items: center;">
                                            <span>额定吊重:{{liftPart.weightReay}}kg</span>
                                            <span>额定高度:{{liftPart.height}}m</span>
                                        </p>
                                        <p style="width:100%;height:60rem;position: relative;text-align: center;">实时速度：{{liftPart.speed}}m/s</p>
                                        <div style="width:100%;height:160rem;position: relative;text-align: center;">
                                            <img src="../../assets/image/ele-stop.png" style="height:140rem;width:100rem;" />
                                        </div>
                                    </div>
                                    <div style="width:66%;height:100%;">
                                        <div style="width:100%;height:450rem;position: relative;display:flex;flex-wrap:wrap;padding-top: 20rem;">
                                            <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">实时重量</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.weight}}吨</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">前面</p>
                                                <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                    <span v-if="liftPart.systemStatusForelockStatus=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusForelockStatus=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.msqm}}</p>
                                            </div>
                                            <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">重量百分比</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.weightPercent}}%</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">后门</p>
                                                <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                    <span v-if="liftPart.systemStatusBehindlockStatus=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusBehindlockStatus=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.mshm}}</p>
                                            </div>
                                            <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">实时高度</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.height}}米</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">姿态状态</p>
                                                <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                    <span v-if="liftPart.systemStatusTilt=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusTilt=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.qxyj}}</p>
                                            </div>
                                            <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                                <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.6);">高度百分比</p>
                                                <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                                    <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                                    <span>{{liftPart.heightPercent}}%</span>
                                                </p>
                                                <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">重量状态</p>
                                                <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                                    <span v-if="liftPart.systemStatusWeight=='1'" class="color6">预警</span>
                                                    <span v-else-if="liftPart.systemStatusWeight=='2'" style="color:red;">报警</span>
                                                    <span v-else class="color10">正常</span>
                                                </p>
                                                <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.zlyj}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.index=='23' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> {{project.name}}—扬尘监测 </p>
                                <div style="width:100%;height:700rem;position: relative;margin-top:20rem;display:flex;">
                                    <div style="width:66%;height:100%;position: relative;">
                                        <div id="dust1" style="width:100%; height:100%;"></div>
                                    </div>
                                    <div style="width:34%;height:100%;position: relative;">
                                        <div id="dust2" style="width:100%; height:100%;"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.index=='24' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                                <p class="item-title"> {{project.name}}—卸料平台 </p>
                                <div style="width:180rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                                    <div class="main-left-item" v-for="(item,index) in unloadList" :key="index" :class="{'curUnload':unloadId==item.verifyCode}" @click="changeTower(item)">
                                        <p class="name nowrap" style="width:100%;height:40rem;">{{item.unloadName}}</p>
                                        <p class="state color8" style="width:100%;text-align: right;margin-top: 12rem;" v-if="item.status=='0'">离线</p>
                                        <p class="state color10" style="width:100%;text-align: right;margin-top: 12rem;" v-else-if="item.status=='1'" >在线</p>
                                    </div>
                                </div>
                                <div style="width:calc( 100% - 180rem );height:750rem;position: relative;margin-left:180rem;">
                                    <p style="width:100%;height:100rem;position: relative;display:flex;">
                                        <span style="width: 60%;text-align: left;padding-left: 20rem;">实时数据</span>
                                        <span style="font-size:14rem;transform: scale(0.8);">{{unloadInfo.updateDate}}</span>
                                    </p>
                                    <div style="width:100%;height:600rem;position: relative;display:flex;flex-wrap:wrap;">
                                        <div style="width:100%;height:100rem;position: relative;display:flex;">
                                            <p style="width:33%;height:100rem;font-size:14rem;transform: scale(0.8);text-align: left;">设备号：{{unloadInfo.verifyCode}}</p>
                                            <p class="nowrap" style="width:33%;height:100rem;font-size:14rem;transform: scale(0.8);text-align: left;">设备名称：{{unloadInfo.unloadName}}</p>
                                            <p style="width:33%;height:100rem;font-size:14rem;transform: scale(0.8);text-align: left;top: -10rem;">设备电量：{{unloadInfo.electricQuantity}}%</p>
                                        </div>
                                        <div style="width:50%;height:400rem;position: relative;">
                                            <div id="unload1" style="width:100%;height:100%;position: relative;top:0;left:0;"></div>
                                            <p style="width:100%;height:60rem;top: -20rem;">
                                                <span style="padding:5rem 10rem;color:#FE0000;background:rgb(240 240 240 / 0.4);font-size:14rem;">偏置值：{{unloadInfo.bias}}</span>
                                            </p>
                                        </div>
                                        <div style="width:50%;height:400rem;position: relative;">
                                            <div id="unload3" style="width:100%;height:100%;position: relative;top:0;left:0;"></div>
                                            <p style="width:100%;height:60rem;top: -30rem;">
                                                <span style="padding:5rem 10rem;color:#FE0000;background:rgb(240 240 240 / 0.4);font-size:14rem;">报警：{{unloadInfo.alarmWeight}}吨</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </li>
                    </draggable>
                </div>
                <!-- 第四列 -->
                <div class="list-group-box1" style="width:1880rem;height:2535rem;margin:0;">
                    <div style="width:100%;height:1655rem;position: relative;padding:0 20rem;background: rgba(13, 25, 57, 0.45);border: 2rem solid #707070;margin-top: 20rem;">
                        <p class="item-title"> 项目绘制图 </p>
                        <div style="width:100%;height:1500rem;padding-top: 70rem;">
                            <baidu-map class="map-box" :center="center" :zoom="12" @click="mapClickFun" @ready="handler" id="xjMap" style="height:100%;width:100%;">
                                <bm-ground v-if="mapURL!=''" style="z-index:-1" :bounds="{ne: {lng: 117.237491, lat: 31.909984}, sw:{lng: 117.026497000, lat: 31.760013000}}" :opacity='1' :imageURL="mapURL"></bm-ground>
                                <bm-marker v-for="(item,index) in points" :key="index" :position="item.position" :rotation='item.angle' :icon="{url: require('../../assets/image/vis/worker.png'), size: {width: 50, height: 50}}">
                                </bm-marker>
                            </baidu-map>
                        </div>
                    </div>
                    <div style="width:100%;height:1826rem;position: relative;background: rgba(13, 25, 57, 0.45);border: 2rem solid #707070;margin-top:20rem;">
                        <p class="item-title"> <span class="nowrap" style="width: 100%;text-align: center;color:#34ECFF;">{{project.name}}—现场监控 </span></p>
                        <div style="width:100%;height:1654rem;position: relative;padding:20rem;display: flex;flex-wrap: wrap;align-content: flex-start;justify-content: flex-start;">
                            <div class="monitorbox-item" v-for="(item,index) in monitorList" :key="index">
                                <div class="item-monitor">
                                    <iframe width="100%" height="100%" :src='item.showUrl' style="border: 0;height: 100%;"></iframe>
                                </div>
                                <p class="item-info">
                                    <span class="name nowrap">{{item.name}}</span>
                                    <img v-if="item.type=='1'" src="../../assets/image/visual/gun.png" />
                                    <img v-else-if="item.type=='2'" src="../../assets/image/visual/ptz.png" />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 第五列 -->
            <div style="width:846rem;height:100%;padding-top:150rem;">
                <draggable class="list-group" tag="ul" :list="list3" group="project" @change="log" style="background: transparent;padding:0;">
                    <li class="list-group-item" v-for="(element, index) in list3" :key="index">
                        <!-- 第五列-替补（list0） -->
                        <!-- <div v-if="element.index=='1' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 劳务统计 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在职总数</p>
                                <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在场人数</p>
                                <p style="width:33%;position: relative;text-align: center;padding:0 18rem;">在场率</p>
                            </div>
                            <div style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                <p style="width:33%;padding:0 18rem;">
                                    <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                    <span class="nowrap" style="display: inline-block;width: 100%;">{{person.zaiZhiCount}}</span>
                                </p>
                                <p style="width:33%;padding:0 18rem;">
                                    <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                    <span class="nowrap" style="display: inline-block;width: 100%;">{{person.zaiChangCount}}</span>
                                </p>
                                <p style="width:33%;padding:0 18rem;">
                                    <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                    <span class="nowrap" style="display: inline-block;width: 100%;">{{person.bilv}}%</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="element.index=='2' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <div style="width:100%;height:60rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                                <p>
                                    <span class="crile"></span>
                                    <span style="color:#34ECFF;font-size:22rem;">今日出勤</span>
                                    <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">{{attend.allTeamsCount}}</span>
                                </p>
                            </div>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                                <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">出勤人数</p>
                                <p style="width:30%;position: relative;text-align: center;padding:0 18rem;">出勤率</p>
                            </div>
                            <div style="width:100%;height:300rem;position: relative;overflow: hidden;">
                                <ul>
                                    <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:30%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">管理人员</span>
                                        </p>
                                        <p style="width:40%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageCount}}</span>
                                        </p>
                                        <p style="width:30%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.manageRate}}%</span>
                                        </p>
                                    </li>
                                    <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:30%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">建筑工人</span>
                                        </p>
                                        <p style="width:40%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersCount}}</span>
                                        </p>
                                        <p style="width:30%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li1.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.workersRate}}%</span>
                                        </p>
                                    </li>
                                    <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:30%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">特种人员</span>
                                        </p>
                                        <p style="width:40%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialCount}}</span>
                                        </p>
                                        <p style="width:30%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: 6rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{attend.specialRate}}%</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="element.index=='3' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <div style="width:100%;height:80rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                                <p>
                                    <span class="crile"></span>
                                    <span style="color:#34ECFF;font-size:22rem;">关键岗位履责</span>
                                    <span style="color:#34ECFF;font-size:22rem;margin-left:50rem;">100</span>
                                </p>
                            </div>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:25%;position: relative;text-align: center;padding:0 18rem;"></p>
                                <p style="width:25%;position: relative;text-align: center;">在职人数</p>
                                <p style="width:25%;position: relative;text-align: center;">在场人数</p>
                                <p style="width:25%;position: relative;text-align: center;">出勤人数</p>
                            </div>
                            <div style="width:100%;height:400rem;position: relative;overflow: hidden;">
                                <ul>
                                    <li v-for="(item,index) in keyList" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:25%;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.lable}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -4rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.count}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -4rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.present}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:42rem;position: absolute;left: calc( 50% - 43rem );top: -4rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.attend}}</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div v-if="element.index=='4' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <div style="width:100%;height:80rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                                <p>
                                    <span class="crile"></span>
                                    <span style="color:#34ECFF;font-size:22rem;">人员动态</span>
                                </p>
                            </div>
                            <div style="width:100%;height:100rem;position: relative;display:flex;padding:0 36rem;align-items: center;">
                                <p style="font-size:18rem;color:#fff;padding-left:30rem;">累计采集{{syn.zs}}人</p>
                                <p style="font-size:18rem;color:#fff;padding-left:50rem;">实名占比{{syn.smRate}}</p>
                            </div>
                            <div style="width:100%;height:500rem;position: relative;display:flex;">
                                <div style="width: 50%;height: 100%;">
                                    <div id="myChart1" style="width:100%; height:100%"></div>
                                </div>
                                <div class="first-gress-con" style="width: 50%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                    <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">在职人员({{syn.zz}}/{{syn.zs}})</p>
                                    <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.zzLv)" :stroke-width="20"></el-progress></p>
                                    <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未在职人员({{syn.wzz}}/{{syn.zs}})</p>
                                    <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.wzzLv)" :stroke-width="20" color="#FF9F20"></el-progress></p>
                                    <p style="color:#fff;display:flex;align-items: flex-end;padding-left:20rem;">未实名人员({{syn.lz}}/{{syn.zs}})</p>
                                    <p style="width: 100%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(syn.lzLv)" :stroke-width="20" color="#E66E3A"></el-progress></p>
                                </div>
                            </div>
                        </div>

                        <div v-if="element.index=='5' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <div style="width:100%;height:80rem;position: relative;display:flex;justify-content: space-between;padding:0 36rem;">
                                <p>
                                    <span class="crile"></span>
                                    <span style="color:#34ECFF;font-size:22rem;">安全教育</span>
                                </p>
                            </div>
                            <div style="width:100%;height:420rem;position: relative;overflow: hidden;display:flex;">
                                <div style="width:50%;height:100%;position: relative;">
                                    <div id="teach" style="width:100%;height:360rem;position: relative;"></div>
                                    <p>未教育人数   <span style="color:#DE2D21;">0</span>人</p>
                                </div>
                                <div style="width:50%;height:100%;position: relative;">
                                    <div id="exam" style="width:100%;height:360rem;position: relative;"></div>
                                    <p>未考试人数   <span style="color:#DE2D21;">{{edc.nopaper}}</span>人</p>
                                </div>
                            </div>
                        </div>

                        <div v-if="element.index=='6' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <div style="width:100%;height:160rem;position: relative;display:flex;justify-content: space-between;padding:0 0 0 36rem;flex-wrap:wrap;">
                                <p style="width:100%;text-align:left;">
                                    <span class="crile"></span>
                                    <span style="color:#34ECFF;font-size:22rem;">合同信息</span>
                                </p>
                                <p style="color:#fff;font-size:12rem;">应签{{agreeNum.yqht}}人</p>
                                <p style="color:#fff;font-size:12rem;">已网签{{agreeNum.ywq}}人</p>
                                <p style="color:#fff;font-size:12rem;">未网签{{agreeNum.wxq}}人</p>
                            </div>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">姓名</p>
                                <p style="width:50%;position: relative;text-align: center;padding:0 18rem;">入职时间</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;">合同状态</p>
                            </div>
                            <div style="width:100%;height:640rem;position: relative;overflow: hidden;">
                                <ul :class="{anim1:animate1==true}">
                                    <li v-for="(item,index) in tableAgree" :key="index" style="height:80rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                        </p>
                                        <p style="width:50%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.create_date}}</span>
                                        </p>
                                        <p style="width:25%;padding:0;">
                                            <span v-if="item.status=='已网签'" style="display: inline-block;width: 100%;color:#FFFFFF;">已网签</span>
                                            <span v-else style="display: inline-block;width: 100%;color:#E66E3A;">未网签</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                        <!-- 第五列- 替补（list1） -->
                        <!-- <div v-if="element.index=='7' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 产值进度 </p>
                            <div style="width:100%;height:500rem;position: relative;display:flex;">
                                <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                    <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计提报产值</p>
                                    <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                        229
                                        <img src="../../assets/image/visual/val1.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                    </div>
                                </div>
                                <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                    <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计审定产值</p>
                                    <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                        229
                                        <img src="../../assets/image/visual/val2.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                    </div>
                                </div>
                                <div style="width:33.33%;height:100%;display:flex;flex-wrap: wrap;justify-content: center;align-content: center;">
                                    <p style="width:100%;height:120rem;display:flex;justify-content: center;transform: scale(0.8);margin-bottom: 20rem;">累计合同额</p>
                                    <div style="width:200rem;height:200rem;position: relative;display: flex;align-items: center;justify-content: center;">
                                        229
                                        <img src="../../assets/image/visual/val3.png" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="element.index=='8' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 产值进度明细 </p>
                            <div style="width:100%;height:900rem;position: relative;overflow: hidden;">
                                <ul :class="{anim2:animate2==true}">
                                    <li v-for="(item,index) in progressList" :key="index" style="height:300rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;flex-wrap:wrap;">
                                        <p style="width:100%;padding:0 18rem;height:80rem;padding-top: 15rem;">
                                            <span class="nowrap" style="display: inline-block;width: 50%;text-align: left;">{{item.projectName}}</span>
                                            <span class="nowrap" style="display: inline-block;width: 50%;">合同额:{{item.price}}万</span>
                                        </p>
                                        <div style="width:100%;padding:0 18rem;display:flex;align-items: center;height:80rem;justify-content: center;">
                                            <span style="margin-right:10rem;">本次审定</span>
                                            <p style="width: 50%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(item.pay.apprlv)>100?100:parseFloat(item.pay.apprlv)" :stroke-width="20"></el-progress></p>
                                            <span>{{item.pay.apprMoney}}万</span>
                                        </div>
                                        <div style="width:100%;padding:0 18rem;display:flex;align-items: center;height:80rem;justify-content: center;">
                                            <span style="margin-right:10rem;">累计审定</span>
                                            <p style="width: 50%;position: relative;height: 20rem;"><el-progress :show-text="false" :percentage="parseFloat(item.pay.totalLv)>100?100:parseFloat(item.pay.totalLv)" color="#9486FF" :stroke-width="20"></el-progress></p>
                                            <span>{{item.pay.total0}}万</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div v-if="element.index=='9' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 关键节点进度 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:30%;position: relative;text-align: center;padding:0 18rem;"></p>
                                <p style="width:35%;position: relative;text-align: center;padding:0 18rem;">正常项目数</p>
                                <p style="width:35%;position: relative;text-align: center;padding:0 18rem;">滞后项目数</p>
                            </div>
                            <div style="width:100%;height:600rem;position: relative;overflow: hidden;">
                                <ul :class="{anim3:animate3==true}">
                                    <li v-for="(item,index) in nodeList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:30%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.nodeTypeName}}</span>
                                        </p>
                                        <p style="width:40%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:52rem;position: absolute;left: calc( 50% - 43rem );top: 0rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.normalCount}}</span>
                                        </p>
                                        <p style="width:30%;padding:0 18rem;">
                                            <img src="../../assets/image/visual/li0.png" style="width:86rem;height:52rem;position: absolute;left: calc( 50% - 43rem );top: 0rem;" />
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.delayCount}}</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="element.index=='10' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 质量安全 </p>
                            <div style="width:100%;height:550rem;position: relative;display:flex;">
                                <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                    <div id="safeEnt1" style="width:100%; height:260rem;position: relative;"></div>
                                    <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                    <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#9285F7;"></span>问题已处理</p>
                                </div>
                                <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                    <div id="safeEnt2" style="width:100%; height:260rem;position: relative;"></div>
                                    <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                    <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#15D2B1;"></span>问题已处理</p>
                                </div>
                                <div style="width:33.33%;height:100%;display:flex;flex-wrap:wrap;padding-top: 40rem;">
                                    <div id="safeEnt3" style="width:100%; height:260rem;position: relative;"></div>
                                    <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#D5D6D9;"></span>问题未处理</p>
                                    <p style="width:100%;height:100rem;display:flex;align-items: center;justify-content: center;transform: scale(0.8);"><span class="crile" style="background:#2299F1;"></span>问题已处理</p>
                                </div>
                            </div>
                        </div>
                        <div v-if="element.index=='11' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 短信预警 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:40%;position: relative;text-align: center;padding:0 18rem;">事项</p>
                                <p style="width:60%;position: relative;text-align: center;padding:0 18rem;">内容</p>
                            </div>
                            <div style="width:100%;height:800rem;position: relative;overflow: hidden;">
                                <ul>
                                    <li style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:40%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;"></span>
                                        </p>
                                        <p style="width:60%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;"></span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div> -->
                        <!-- lsit3 -->
                        <!-- <div v-if="element.index=='13' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> {{project.name}}—质量安全 </p>
                            <div style="width:100%;height:1200rem;position: relative;display:flex;flex-wrap:wrap;">
                                <div style="width:100%;height:50%;position: relative;display:flex;flex-wrap:wrap;">
                                    <p style="width:100%;font-size:20rem;padding-bottom: 20rem;position: relative;height:200rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">项目检查  {{safePro.projectAllQsCount}}次</p>
                                    <div style="width:100%;height:400rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                        <div id="safe1" style="width:100%; height:360rem;"></div>
                                    </div>
                                </div>
                                <div style="width:100%;height:50%;position: relative;display:flex;flex-wrap:wrap;">
                                    <p style="width:100%;font-size:20rem;padding-bottom: 20rem;position: relative;height:200rem;display: flex;align-items: flex-end;align-content: center;justify-content: center;">公司检查  {{safePro.entAllQsCount}}次</p>
                                    <div style="width:100%;height:400rem;position: relative;display:flex;justify-content: center;flex-wrap:wrap;align-content: flex-start;">
                                        <div id="safe2" style="width:100%; height:360rem;"></div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div v-if="element.index=='5' && element.show" class="item-div" style="padding: 0 20rem;" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 安全教育</p>
                            <div style="width:100%;height:1200rem;position: relative;overflow: hidden;display:flex;flex-wrap: wrap;">
                                <div style="width:100%;height:50%;position: relative;">
                                    <div id="teach" style="width:100%;height:calc( 100% - 100rem );position: relative;"></div>
                                    <p>未教育人数   <span style="color:#DE2D21;">0</span>人</p>
                                </div>
                                <div style="width:100%;height:50%;position: relative;">
                                    <div id="exam" style="width:100%;height:calc( 100% - 100rem );position: relative;"></div>
                                    <p>未考试人数   <span style="color:#DE2D21;">{{edc.nopaper}}</span>人</p>
                                </div>
                            </div>
                        </div>
                        <div v-if="element.index=='15' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 塔吊安装统计 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">项目</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">安装数量</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">联网状态</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">超重预警</p>
                            </div>
                            <div style="width:100%;height:980rem;position: relative;overflow: hidden;">
                                <ul :class="{anim4:animate4==true}">
                                    <li v-for="(item,index) in towerEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:25%;padding:0;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                        </p>
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>
                        <div v-if="element.index=='16' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 卸料平台安装统计 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;">超重预警</p>
                            </div>
                            <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                                <ul :class="{anim4:animate5==true}">
                                    <li v-for="(item,index) in unloadEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="element.index=='17' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 高支模安装统计 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">项目</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">安装数量</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">联网状态</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">压力预警</p>
                            </div>
                            <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                                <ul :class="{anim4:animate6==true}">
                                    <li v-for="(item,index) in highEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.pressure}}次</span>
                                        </p>
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>

                        <div v-if="element.index=='18' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 升降机安装统计 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">项目</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">安装数量</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">联网状态</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;transform: scale(0.9);">超重预警</p>
                            </div>
                            <div style="width:100%;height:806rem;position: relative;overflow: hidden;">
                                <ul :class="{anim4:animate7==true}">
                                    <li v-for="(item,index) in eleEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.weight}}次</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div v-if="element.index=='19' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                            <p class="item-title"> 混凝土测温安装统计 </p>
                            <div style="width:100%;height:100rem;position: relative;display:flex;align-items: center;margin-top:30rem;">
                                <p style="width:25%;position: relative;text-align: center;padding:0 18rem;">项目</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;">安装数量</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;">联网状态</p>
                                <p style="width:25%;position: relative;text-align: center;padding:0;">测温预警</p>
                            </div>
                            <div style="width:100%;height:500rem;position: relative;overflow: hidden;">
                                <ul :class="{anim4:animate8==true}">
                                    <li v-for="(item,index) in mixedEntList" :key="index" style="height:100rem;align-content: center;align-items: center;width: 100%;position: relative;display: flex;">
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.name}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;">{{item.all}}台</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;"><span style="color:#0BA204;">联网</span>{{item.online+'/'+item.all}}</span>
                                        </p>
                                        <p style="width:25%;padding:0 18rem;">
                                            <span class="nowrap" style="display: inline-block;width: 100%;color:#FF0303;">{{item.warning}}次</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </draggable>
            </div>
        </div>
        <!-- 第六列 -->
        <div class="list-group-box1" style="width:1380rem;">
            <draggable class="list-group" tag="ul" :list="list4" group="project1" @change="log" style="background:transparent;">
                <li class="list-group-item" v-for="(element, index) in list4" :key="index">
                    <!-- list4 -->
                    <div v-if="element.index=='20' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 设备运行监测 </p>
                        <div class="item-div" style="margin-top:64rem;margin-bottom: 64rem;">
                            <p class="item-head-p" style="height: 160rem;">
                                <span></span>
                                <span class="b-line">考勤机</span>
                                <span class="b-line">塔吊</span>
                                <span class="b-line">监控</span>
                                <span class="b-line">升降机</span>
                                <span class="b-line">高支模</span>
                                <span class="b-line">卸料</span>
                                <span class="b-line">螺帽</span>
                                <span class="b-line">混凝土</span>
                            </p>
                            <div class="item1-con" style="padding:0;">
                                <div class="device-item" style="height: 160rem;">
                                    <p>总数</p>
                                    <p class="b-line" v-for="item in equipStatusList" :key="item.index">{{item.sum}}</p>
                                </div>
                                <div class="device-item1" style="height: 160rem;">
                                    <p>在线</p>
                                    <p v-for="item in equipStatusList" :key="item.index">
                                        <img src="../../assets/image/vis/dev-bg.gif" style="width:100rem;height:100rem;" />
                                        <span class="item-span" style="left:0;">{{item.online}}</span>
                                    </p>
                                </div>
                                <div class="device-item1" style="height: 160rem;">
                                    <p>离线</p>
                                    <p v-for="item in equipStatusList" :key="item.index">
                                        <img src="../../assets/image/vis/dev-bg1.png" style="width:120rem;height:120rem;" />
                                        <span class="item-span" style="left:0;top:0;">{{item.offline}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='21' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> <span class="nowrap" style="width: 100%;text-align: center;color:#34ECFF;">{{project.name}}—塔吊监测 </span></p>
                        <div style="width:200rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                            <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                                <p class="name nowrap" style="width:100%;height:40rem;">{{item.name}}</p>
                                <p class="state color8" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-if="item.online=='离线'">离线</p>
                                <p class="state color10" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else-if="item.online=='正常'" >正常</p>
                                <p class="state color9" style="width:100%;text-align: right;transform: scale(0.8);margin-top: 6rem;" v-else >{{item.online}}</p>
                            </div>
                        </div>
                        <div style="width:calc( 100% - 200rem );height:1150rem;position: relative;margin-left:200rem;">
                            <div style="width: 100%;height: 100%;position: relative;display: flex;flex-wrap: wrap;">
                                <div style="width: 50%;height: 450rem;position: relative;padding: 20rem 10rem 10rem;display: flex;flex-wrap: wrap;">
                                    <p style="text-align: center;font-size:20rem;height:80rem;width:100%;top: -3px">实时监控</p>
                                    <div style="width:100%;height:calc( 100% - 30rem );padding:0rem 30rem;">
                                        <p class="real-data-l-item">
                                            <span style="width: 70%;">设备幅度</span>
                                            <span style="padding:0 10rem;">{{ towerPart.radius||0 }}m</span>
                                        </p>
                                        <p class="real-data-l-item">
                                            <span style="width: 70%;">吊钩高度</span>
                                            <span style="padding:0 10rem;">{{ towerPart.hight||0 }}m</span>
                                        </p>
                                        <p class="real-data-l-item">
                                            <span style="width: 70%;">额定吊重</span>
                                            <span style="padding:0 10rem;">{{ towerPart.ratedWeight||0 }}吨</span>
                                        </p>
                                        <p class="real-data-l-item">
                                            <span style="width: 70%;">塔吊力矩</span>
                                            <span style="padding:0 10rem;">{{ towerPart.lijupercent||0 }}N</span>
                                        </p>
                                        <p class="real-data-l-item">
                                            <span style="width: 70%;">吊重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                            <span style="padding:0 10rem;">{{ towerPart.loadweightr||0 }}吨</span>
                                        </p>
                                        <p class="real-data-l-item">
                                            <span style="width: 70%;">前倾角&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                            <span style="padding:0 10rem;">{{towerPart.fall||0}}度</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="real-clock" style="width:50%;height: 450rem;">
                                    <p style="text-align: left;padding-left:10rem;font-size:20rem;height:80rem;width:100%;text-align: center;">塔吊回转</p>
                                    <div class="real-clock-con" id="wrap">
                                        <ul id="list">
                                            <li></li><li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li><li></li>
                                            <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                                        </ul>
                                        <div class="icon"></div>
                                        <div
                                            id="clockLine"
                                            :style="{'-webkit-transform': 'rotate('+towerPart.angle+'deg)'}"
                                        ></div>
                                        <div class="num0">0</div>
                                        <div class="num90">90</div>
                                        <div class="num180">180</div>
                                        <div class="num270">270</div>
                                    </div>
                                </div>
                                <div style="width: 100%;height: 680rem;position: relative;padding: 10rem;display: flex;flex-wrap: wrap;">
                                    <p style="text-align: center;font-size:20rem;height:80rem;width:100%;">吊钩可视化</p>
                                    <div v-if="cameraData && cameraData.serial" style="width:100%;height:calc( 100% - 30rem );position: relative;">
                                        <iframe width="100%" height="100%" :src='towerVideo' style="border: 0;height: 100%;"></iframe>
                                    </div>
                                    <div v-else style="width:100%;height:calc( 100% - 80rem );position: relative;">
                                        <img src="../../assets/image/monitorBg.png" style="width:100%;height:100%;" />
                                        <p style="width:100%;height:40rem;text-align: center;position: absolute;top:65%;left:0;">暂无视频</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.index=='22' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"><span class="nowrap" style="width: 100%;text-align: center;color:#34ECFF;"> {{project.name}}—升降机监测</span> </p>
                        <div style="width:100%;height:700rem;position: relative;display:flex;padding:20rem;">
                            <div style="width:34%;height:100%;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;height:120rem;position: relative;padding-top: 30rem;display:flex;justify-content:space-between;align-items: center;display:flex;">
                                    <span style="display: inline-block;width: 100%;text-align: center;height: 90rem;">额定吊重:{{liftPart.weightReay}}kg</span>
                                    <span style="display: inline-block;width: 100%;text-align: center;height: 90rem;">额定高度:{{liftPart.height}}m</span>
                                </p>
                                <p style="width:100%;height:90rem;position: relative;text-align: center;padding-top: 30rem;">实时速度：{{liftPart.speed}}m/s</p>
                                <div style="width:100%;height:260rem;position: relative;text-align: center;">
                                    <img src="../../assets/image/ele-stop.png" style="height:230rem;width:160rem;" />
                                </div>
                            </div>
                            <div style="width:66%;height:100%;">
                                <div style="width:100%;height:650rem;position: relative;display:flex;flex-wrap:wrap;padding-top: 20rem;">
                                    <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                        <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.8);padding: 0 18rem;">实时重量</p>
                                        <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                            <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                            <span>{{liftPart.weight}}吨</span>
                                        </p>
                                        <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">前面</p>
                                        <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                            <span v-if="liftPart.systemStatusForelockStatus=='1'" class="color6">预警</span>
                                            <span v-else-if="liftPart.systemStatusForelockStatus=='2'" style="color:red;">报警</span>
                                            <span v-else class="color10">正常</span>
                                        </p>
                                        <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.msqm}}</p>
                                    </div>
                                    <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                        <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">重量百分比</p>
                                        <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                            <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                            <span>{{liftPart.weightPercent}}%</span>
                                        </p>
                                        <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">后门</p>
                                        <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                            <span v-if="liftPart.systemStatusBehindlockStatus=='1'" class="color6">预警</span>
                                            <span v-else-if="liftPart.systemStatusBehindlockStatus=='2'" style="color:red;">报警</span>
                                            <span v-else class="color10">正常</span>
                                        </p>
                                        <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.mshm}}</p>
                                    </div>
                                    <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                        <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.8);padding: 0 18rem;">实时高度</p>
                                        <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                            <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                            <span>{{liftPart.height}}米</span>
                                        </p>
                                        <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">姿态状态</p>
                                        <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                            <span v-if="liftPart.systemStatusTilt=='1'" class="color6">预警</span>
                                            <span v-else-if="liftPart.systemStatusTilt=='2'" style="color:red;">报警</span>
                                            <span v-else class="color10">正常</span>
                                        </p>
                                        <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.qxyj}}</p>
                                    </div>
                                    <div style="width:100%;height:60rem;position: relative;display:flex;align-items: center;">
                                        <p style="width:200rem;height:40rem;display:flex;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">高度百分比</p>
                                        <p style="width:100rem;height:40rem;background:url(../../assets/image/visual/li1.png);background-size:100% 100%;display: flex;justify-content: center;align-items: center;">
                                            <img src="../../assets/image/visual/li1.png" style="width:100rem;height:40rem;position: absolute;top: 0;left: 0;" />
                                            <span>{{liftPart.heightPercent}}%</span>
                                        </p>
                                        <p style="width:calc( 33% - 50rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">重量状态</p>
                                        <p style="width:calc( 33% - 80rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">
                                            <span v-if="liftPart.systemStatusWeight=='1'" class="color6">预警</span>
                                            <span v-else-if="liftPart.systemStatusWeight=='2'" style="color:red;">报警</span>
                                            <span v-else class="color10">正常</span>
                                        </p>
                                        <p style="width:calc( 33% - 20rem );height:40rem;display: flex;justify-content: center;align-items: center;transform: scale(0.8);">预警次数  {{liftPart.zlyj}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='23' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> <span class="nowrap" style="width: 100%;text-align: center;color:#34ECFF;">{{project.name}}—扬尘监测</span> </p>
                        <div style="width:100%;height:915rem;position: relative;margin-top:20rem;display:flex;">
                            <div style="width:66%;height:100%;position: relative;">
                                <div id="dust1" style="width:100%; height:100%;"></div>
                            </div>
                            <div style="width:34%;height:100%;position: relative;">
                                <div id="dust2" style="width:100%; height:100%;"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='24' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title" > <span class="nowrap" style="width: 100%;text-align: center;color:#34ECFF;">{{project.name}}—卸料平台</span> </p>
                        <div style="width:180rem;height:100%;position: absolute;top:0;left:0;background: rgba(19, 145, 218, 0.2);border: 1rem solid #1391DA;overflow: auto;">
                            <div class="main-left-item" v-for="(item,index) in unloadList" :key="index" :class="{'curUnload':unloadId==item.verifyCode}" @click="changeTower(item)">
                                <p class="name nowrap" style="width:100%;height:40rem;">{{item.unloadName}}</p>
                                <p class="state color8" style="width:100%;text-align: right;margin-top: 12rem;" v-if="item.status=='0'">离线</p>
                                <p class="state color10" style="width:100%;text-align: right;margin-top: 12rem;;" v-else-if="item.status=='1'" >在线</p>
                            </div>
                        </div>
                        <div style="width:calc( 100% - 180rem );height:750rem;position: relative;margin-left:180rem;">
                            <p style="width:100%;height:100rem;position: relative;display:flex;">
                                <span style="width: 60%;text-align: left;padding-left: 20rem;">实时数据</span>
                                <span style="font-size:14rem;transform: scale(0.8);">{{unloadInfo.updateDate}}</span>
                            </p>
                            <div style="width:100%;height:600rem;position: relative;display:flex;flex-wrap:wrap;">
                                <div style="width:100%;height:100rem;position: relative;display:flex;">
                                    <p style="width:33%;height:100rem;font-size:14rem;transform: scale(0.8);text-align: left;">设备号：{{unloadInfo.verifyCode}}</p>
                                    <p class="nowrap" style="width:33%;height:100rem;font-size:14rem;transform: scale(0.8);text-align: left;">设备名称：{{unloadInfo.unloadName}}</p>
                                    <p style="width:33%;height:100rem;font-size:14rem;transform: scale(0.8);text-align: left;top: -10rem;">设备电量：{{unloadInfo.electricQuantity}}%</p>
                                </div>
                                <div style="width:50%;height:400rem;position: relative;">
                                    <div id="unload1" style="width:100%;height:100%;position: relative;top:0;left:0;"></div>
                                    <p style="width:100%;height:60rem;top: -20rem;">
                                        <span style="padding:5rem 10rem;color:#FE0000;background:rgb(240 240 240 / 0.4);font-size:14rem;">偏置值：{{unloadInfo.bias}}</span>
                                    </p>
                                </div>
                                <div style="width:50%;height:400rem;position: relative;">
                                    <div id="unload3" style="width:100%;height:100%;position: relative;top:0;left:0;"></div>
                                    <p style="width:100%;height:60rem;top: -30rem;">
                                        <span style="padding:5rem 10rem;color:#FE0000;background:rgb(240 240 240 / 0.4);font-size:14rem;">报警：{{unloadInfo.alarmWeight}}吨</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 第六列-替补（list2） -->
                    <!-- <div v-if="element.index=='12' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> 安康码管控系统 </p>
                        <div style="width:100%;height:700rem;position: relative;display:flex;">
                            <div style="width:50%;height:100%;position: relative;margin-top:20rem;padding:20rem 20rem 0;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;height:100rem;position: relative;">
                                    累计统计登记人数  {{anKang.CumulativeDay}}
                                </p>
                                <div style="width:100%;height:100rem;position: relative;display:flex;flex-wrap:wrap;justify-content: flex-end;">
                                    <p><span class="crile" style="background:#0CCF93;top: -8rem;"></span>正常绿码  {{anKang.green1}}</p>
                                    <p style="margin-left:20rem;"><span class="crile" style="background:#F8DA2A;top: -8rem;"></span>异常黄码  {{anKang.yellow1}}</p>
                                    <p><span class="crile" style="background:#FB2121;top: -8rem;"></span>异常红码  {{anKang.red1}}</p>
                                </div>
                                <div style="width:100%;height:400rem;position: relative;padding-top:10rem;">
                                    <div id="ankang1" style="width:100%; height:100%;"></div>
                                </div>
                            </div>
                            <div style="width:50%;height:100%;position: relative;margin-top:20rem;padding:20rem 20rem 0;display:flex;flex-wrap:wrap;">
                                <p style="width:100%;height:100rem;position: relative;">
                                    本月统计登记人数  {{anKang.inCumulative}}
                                </p>
                                <div style="width:100%;height:100rem;position: relative;display:flex;flex-wrap:wrap;justify-content: flex-end;">
                                    <p><span class="crile" style="background:#0CCF93;top: -8rem;"></span>正常绿码  {{anKang.green2}}</p>
                                    <p style="margin-left:20rem;"><span class="crile" style="background:#F8DA2A;top: -8rem;"></span>异常黄码  {{anKang.yellow2}}</p>
                                    <p><span class="crile" style="background:#FB2121;top: -8rem;"></span>异常红码  {{anKang.red2}}</p>
                                </div>
                                <div style="width:100%;height:400rem;position: relative;padding-top:10rem;">
                                    <div id="ankang2" style="width:100%; height:100%;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="element.index=='25' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title">岗位效能 </p>
                        <div style="width:100%;height:840rem;position: relative;display:flex;flex-wrap:wrap;overflow: hidden;padding-top:40rem;padding-left:20rem;">
                            <ul :class="{anim9:animate9==true}">
                                <li v-for="(item,index) in postEffPro" :key="index" style="width:100%;height:240rem;position: relative;margin-bottom: 30rem;display: flex;flex-wrap:wrap;">
                                    <p style="width:100%;height:80rem;position: relative;text-align: center;">项目名称</p>
                                    <div style="width:100%;height:160rem;position: relative;display:flex;flex-wrap:wrap;">
                                        <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                            <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">项目经理</span>
                                            <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.pmMapsBi}}%</span>
                                        </p>
                                        <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                            <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">总监代表</span>
                                            <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.threeMapsBi}}%</span>
                                        </p>
                                        <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                            <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">总监工程师</span>
                                            <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.fourMapsBi}}%</span>
                                        </p>
                                        <p style="width:50%;height:80rem;position: relative;display:flex;align-content: center;">
                                            <span style="display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">检测负责人</span>
                                            <span style="color:#00C33C;display: inline-block;width: 50%;text-align: left;padding-left: 20rem;">出勤率{{item.fiveMapsBi}}%</span>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="element.index=='14' && element.show" class="item-div" :style="{'margin-top':element.margin+'rem'}" :class="(element.border?'borderCss':'')">
                        <p class="item-title"> {{project.name}}—关键人员人脸考勤 </p>
                        <div style="width:100%;height:980rem;position: relative;display:flex;flex-wrap:wrap;overflow: hidden;padding-top:40rem;padding-left:20rem;">
                            <div v-for="(item,index) in keyPersonPro" :key="index" style="width:100%;height:300rem;position: relative;margin-bottom: 20rem;display: flex;">
                                <div style="width:50%;height:100%;background:rgb(134 234 255 / 8%);display:flex;padding:10rem;justify-content: space-between;">
                                    <div style="width:calc( 100% - 200rem );height:100%;position: relative;display:flex;flex-wrap:wrap;justify-content:center;">
                                        <img :src="item.facePhoto" style="max-width:100%;height:180rem;position: relative;" />
                                        <p style="width:100%;text-align: center;">抓拍人脸</p>
                                    </div>
                                    <div style="width:400rem;height:100%;position: relative;">
                                        <el-progress type="circle" :percentage="parseFloat(item.contrast)"></el-progress>
                                    </div>
                                    <div style="width:calc( 100% - 200rem );height:100%;position: relative;display:flex;flex-wrap:wrap;justify-content:center;">
                                        <img :src="item.uploadFile" style="max-width:100%;height:180rem;position: relative;" />
                                        <p style="width:100%;text-align: center;">比对人脸</p>
                                    </div>
                                </div>
                                <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: space-around;padding-left:30rem;">
                                    <p style="width:100%;position: relative;text-align: left;">姓名：{{item.personName}}</p>
                                    <p style="width:100%;position: relative;text-align: left;">时间：{{item.updateDate}}</p>
                                    <p style="width:100%;position: relative;text-align: left;display:flex;">安康码：
                                        <img v-if="item.healthLevel=='1'" src="../../assets/image/vis/anKang-gress.png" style="width:120rem;height:120rem;" />
                                        <img v-else-if="item.healthLevel=='2'" src="../../assets/image/vis/anKang-yellow.png" style="width:120rem;height:120rem;" />
                                        <img v-else-if="item.healthLevel=='3'" src="../../assets/image/vis/anKang-red.png" style="width:120rem;height:120rem;" />
                                        <img v-else src="../../assets/image/vis/anKang-no.png" style="width:120rem;height:120rem;" />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </li>
            </draggable>
            <i class="el-icon-s-tools" style="color:#fff;position: absolute;right: -50rem;top: -50rem;font-size: 50rem;cursor: pointer;" @click="showDialogFun"></i>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="ctrlVis"
            width="3000rem"
            :lock-scroll="false"
            custom-class="bigVitalDia"
            style="height:100%;"
        >
            <div style="width:100%;height:auto;position: relative;">
                <div style="width:100%;height:80rem;position: relative;display:flex;">
                    <p style="width:15%;text-align: center;">适配（像素）</p>
                    <p style="width:20%;text-align: center;">名称</p>
                    <p style="width:15%;text-align: center;">间距（像素）</p>
                    <p style="width:25%;text-align: center;">边框</p>
                    <p style="width:25%;text-align: center;">状态</p>
                </div>
                <ul>
                    <li v-for="(item,index) in modularList" :key="index" style="width:100%;height:100rem;display:flex;">
                        <p style="width:15%;text-align: center;">{{item.width}}</p>
                        <p style="width:20%;text-align: center;">{{item.name}}</p>
                        <p style="width:15%;text-align: center;">
                            <el-input v-model="item.margin" type="number" placeholder="" style="height:60rem;"></el-input>
                        </p>
                        <p style="width:25%;text-align: center;">
                            <el-radio-group v-model="item.border">
                                <el-radio :label="false">隐藏</el-radio>
                                <el-radio :label="true">显示</el-radio>
                            </el-radio-group>
                        </p>
                        <p style="width:25%;text-align: center;">
                            <el-radio-group v-model="item.show">
                                <el-radio :label="true">开启</el-radio>
                                <el-radio :label="false">关闭</el-radio>
                            </el-radio-group>
                        </p>
                    </li>
                </ul>
                <div style="margin-top:30rem;">
                    <el-button @click="ctrlVis = false" style="margin-right:20rem;">取 消</el-button>
                    <el-button @click="refreshCtl" style="margin-left:20rem;">确 定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import draggable from "vuedraggable"
import HighCharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    components: {
        draggable
    },
    data(){
        return{
            timeEnt:60000, //普通
            timePro:120000,//
            drag: false,
            list0:[
                {name:'劳务统计',index:"1",order:0,margin:20,show:true,width:846,border:true},
                {name:'今日出勤',index:"2",order:0,margin:20,show:true,width:846,border:true},
                {name:'在场人员',index:"3",order:1,margin:20,show:true,width:846,border:true},
                {name:'人员动态',index:"4",order:2,margin:20,show:true,width:846,border:true},
                {name:'合同信息',index:"6",order:4,margin:50,show:true,width:846,border:true},
            ],
            list1:[
                {name:'产值进度',index:"7",order:0,margin:20,show:true,width:860,border:true},
                {name:'产值进度明细',index:"8",order:1,margin:20,show:true,width:860,border:true},
                {name:'关键节点进度',index:"9",order:2,margin:48,show:true,width:860,border:true},
                {name:'质量安全',index:"10",order:2,margin:20,show:true,width:860,border:true},
                {name:'短信预警',index:"11",order:2,margin:20,show:true,width:860,border:true},
            ],
            list2:[
                {name:'安康码管控系统',index:"12",order:0,margin:20,show:true,width:1400,border:true},
                {name:'岗位效能',index:"25",order:0,margin:20,show:true,width:1400,border:true},
                {name:'项目-关键人员人脸考勤',index:"14",order:2,margin:48,show:true,width:1400,border:true},
            ],
            list3:[
                {name:'安全教育',index:"5",order:3,margin:20,show:true,width:846,border:false},
                {name:'塔吊安装统计',index:"15",order:0,margin:20,show:true,width:860,border:true},
                {name:'卸料平台安装统计',index:"16",order:1,margin:20,show:true,width:860,border:true},
                {name:'高支模安装统计',index:"17",order:2,margin:20,show:true,width:860,border:true},
                {name:'升降机安装统计',index:"18",order:3,margin:20,show:true,width:860,border:true},
                {name:'混凝土测温安装统计',index:"19",order:4,margin:20,show:true,width:860,border:true},
            ],
            list4:[
                {name:'设备运行监测',index:"20",order:0,margin:20,show:true,width:1400,border:true},
                {name:'项目—塔吊监测',index:"21",order:1,margin:20,show:true,width:1400,border:true},
                {name:'项目—升降机监测',index:"22",order:2,margin:20,show:true,width:1400,border:true},
                {name:'项目—扬尘监测',index:"23",order:2,margin:20,show:true,width:1400,border:true},
                {name:'项目—卸料平台',index:"24",order:2,margin:20,show:true,width:1400,border:true},
            ],
            allList:[  //页面操作弹出框
                {name:'劳务统计',index:"1",order:0,margin:20,show:true,width:846,border:false},
                {name:'今日出勤',index:"2",order:0,margin:20,show:true,width:846,border:false},
                {name:'在场人员',index:"3",order:1,margin:20,show:true,width:846,border:false},
                {name:'人员动态',index:"4",order:2,margin:20,show:true,width:846,border:false},
                {name:'安全教育',index:"5",order:3,margin:20,show:true,width:846,border:false},
                {name:'合同信息',index:"6",order:4,margin:50,show:true,width:846,border:false},
                {name:'产值进度',index:"7",order:0,margin:0,show:true,width:860,border:true},
                {name:'产值进度明细',index:"8",order:1,margin:20,show:true,width:860,border:true},
                {name:'关键节点进度',index:"9",order:2,margin:20,show:true,width:860,border:true},
                {name:'质量安全',index:"10",order:2,margin:20,show:true,width:860,border:true},
                {name:'短信预警',index:"11",order:2,margin:20,show:true,width:860,border:true},
                {name:'安康码管控系统',index:"12",order:0,margin:20,show:true,width:1400,border:true},
                {name:'项目-质量安全',index:"13",order:1,margin:20,show:true,width:1400,border:true},
                {name:'岗位效能',index:"25",order:2,margin:20,show:true,width:1400,border:true},
                {name:'项目-关键人员人脸考勤',index:"14",order:2,margin:20,show:true,width:1400,border:true},
                {name:'塔吊安装统计',index:"15",order:0,margin:20,show:true,width:860,border:true},
                {name:'卸料平台安装统计',index:"16",order:1,margin:20,show:true,width:860,border:true},
                {name:'高支模安装统计',index:"17",order:2,margin:20,show:true,width:860,border:true},
                {name:'升降机安装统计',index:"18",order:3,margin:20,show:true,width:860,border:true},
                {name:'混凝土测温安装统计',index:"19",order:4,margin:20,show:true,width:860,border:true},
                {name:'设备运行监测',index:"20",order:0,margin:20,show:true,width:1400,border:true},
                {name:'项目—塔吊监测',index:"21",order:1,margin:20,show:true,width:1400,border:true},
                {name:'项目—升降机监测',index:"22",order:2,margin:20,show:true,width:1400,border:true},
                {name:'项目—扬尘监测',index:"23",order:2,margin:20,show:true,width:1400,border:true},
                {name:'项目—卸料平台',index:"24",order:2,margin:20,show:true,width:1400,border:true},

            ],
            //定时器集合
            pageTimer:{}, //定义计算器全局变量 0:时间循环 1-8 滚动循环  
            curTime:util.myTime.getAllTime(),//当前时间
            joinType:'', // 判断
            //企业信息
            proInfo:{
                allDay: 0,
                name: "",
                otherDay: 0,
                planDays: 0,
                settlementTotal: 0,
                settlementValue: 0,
            },
            //劳务统计
            person:{
                zaiCeCount:0,
                zaiZhiCount:0,
                zaiChangCount:0,
                bilv:'',
            },

            //今日出勤
            attend:{
                manageCount:0, //管理人员
                manageRate:0,
                workersCount:0,//工人
                workersRate:0,
                specialCount:0,//特种人员
                specialRate:0,
                allTeamsCount:0,
            },
            //人员动态
            syn:{
                zz:0,   //在职
                lz:0,   //离职
                wzz:0,  //未入职
                wsm:0,  //未实名
                sm:0,   //采集人数
                zs:0,   //总人数
                smRate:0,//实名率
                zzLv:0,  //在职比例
                wzzLv:0, //未在职比例
                lzLv:0, //未实名比例
            },
            //关键岗位
            keyList:[],
            keyAll:{  //
                count:0,
                present:0,
                attend:0,
            },
            //教育考试
            edc:{
                allNum: 0,
                paperNum: 0,
                nopaper: 0,
            },
            //合同
            agreeNum:{wxq:0,yqht:0,ywq:0,wlv:0,ylv:0},
            tableAgree:[],//合同列表

            //产值进度明细
            progressList:[],

            //关键节点
            nodeList:[],

            //安康码管控系统
            anKang:{
                CumulativeDay: 0,
                green1: 0,
                green2: 0,
                inCumulative: 0,
                red1: 0,
                red2: 0,
                yellow1: 0,
                yellow2: 0,
            },

            //项目列表
            projectList:[],
            proNum:{
                all: 0,
                jg: { jgfj: 0, jgsz: 0, jgxm: 0 },
                zj: { zjfj: 0, zjsz: 0, zjxm: 0 },
                tg: { tgfj: 0, tjsz: 0, tgxm: 0 },
                sjfj: { fj: 0, sj: 0 }
            },
            project:{
                index:undefined,
                id:'',
                name:''
            },

            //项目质量安全数量
            safePro:{
                entAllQsCount: 0,
                entNoProblemCount: 0,
                entPendingCount: 0,
                entProblemCount: 0,
                entProcessedCount: 0,
                projectAllQsCount: 0,
                projectNoProblemCount: 0,
                projectPendingCount: 0,
                projectProblemCount: 0,
                projectProcessedCount: 0,
            },

            //项目-岗位效能
            postEffPro:[],

            //关键人员人脸考勤
            keyPersonPro:[],

            //地图
            map:undefined,
            center: {
                lng: 117.125979,
                lat: 31.84046
            },
            BMap:undefined,
            curIndex:undefined,//当前地图展示的gps
            points:[],//坐标集
            mapURL:'',

            //视频监控列表
            monitorList:[],

            //塔吊安装统计
            towerEntList:[],
            //卸料平台安装统计
            unloadEntList:[],
            //高支模安装统计
            highEntList:[],
            //升降机安装统计
            eleEntList:[],
            //混凝土安装统计
            mixedEntList:[],

            //设备运行监测
            equipStatusList:[
                {sum:'0',online:'0',offline:'0'},
                {sum:'0',online:'0',offline:'0'},
                {sum:'0',online:'0',offline:'0'},
                {sum:'0',online:'0',offline:'0'},
                {sum:'0',online:'0',offline:'0'},
                {sum:'0',online:'0',offline:'0'},
                {sum:'0',online:'0',offline:'0'},
                {sum:'0',online:'0',offline:'0'},
            ],
            //塔吊列表
            towerlist:[],
            towerId:'',
            towerPart:{}, //当前塔吊信息
            cameraData:{},//塔吊监控

            //升降机
            // liftList:[],
            // liftId:'',
            liftPart:{
                weightReay:0,
                height:0,
                speed:0,
                speedStatus:'',
                weight:0,
                weightPercent:0,
                height:0,
                heightPercent:0,
                systemStatusForelockStatus:'',
                msqm:0,
                systemStatusTilt:'',
                qxyj:0,
                systemStatusWeight:'',
                zlyj:0
            },

            //卸料平台
            unloadList:[],
            unloadId:'',//卸料设备序列号
            unloadInfo:{},

            //弹出框
            ctrlVis:false,
            modularList:[],//模板列表（用于弹出框展示）
            
            //滚动判断
            animate1:false, //合同
            animate2:false,//产值进度
            animate3:false, //关键节点
            animate4:false, //塔吊安装统计
            animate5:false,//卸料平台安装统计
            animate6:false,//高支模安装统计
            animate7:false,//升降机安装统计
            animate8:false,//混凝土安装统计
            animate9:false,//项目-岗位功能
        }
    },
    created(){
        var that = this
        for(var each in this.pageTimer){
            window.clearTimeout(this.pageTimer[each]);
        }
        this.pageTimer['timer0'] = setInterval(function(){
            that.curTime = util.myTime.getAllTime()
        },1000)
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        if(this.groupId =='1263382107619520513'){
            this.mapURL = 'http://47.100.89.71:18004/static/wisdom/wechat/map/6.jpg'
            this.proInfo.name = '创智'
        }else{
            this.mapURL = ''
            if(this.groupId =='1240117140208402434'){
                this.proInfo.name = '祯安'
            }else{
                this.proInfo.name = ''
            }
        }
        if(util.session.get('roleId')=='3'){
            this.joinType = '3'
        }else if(util.session.get('roleId')=='5'){
            this.joinType = '2'
        }
        this.getMonitorToken()
        this.getSortList()//获取排序和信息
        //测试charts
        // this.setSynCaht()//
        
        // this.setEntSafeChat()//建设-质量安全
        // this.setAllAn()//总安康码
        // this.setMonthAn()//本月安康码
        // this.setProSafeChat()//项目-质量安全
        this.getPersonNum() //劳务统计
        this.getAttend()  //今日出勤
        this.getKeyPostion()  //关键岗位
        this.getCai() //人员动态
        this.edcData() //安全教育
        this.getAgreeList() //合同信息
        this.getOutput() //产值进度
        this.getNodeList() //关键节点进度
        this.getSafeEnt()  //质量安全-建设端
        this.getAnKang()  //安康码管控系统
        this.getPostEffEnt() //获取岗位效能
        this.getProjectNum()  //项目数量
        this.getTowerEnt() //塔吊安装统计
        this.getUnloadEnt() //卸料平台安装统计
        this.getHighEnt() //高支模安装统计
        this.getEleEnt() //升降机安装统计
        this.getMixedEnt() //混凝土安装统计
        this.getEquipStatus() //设备运行监测
        
    },
    methods:{
        //获取展示模块数据
        getSortList(){
            var that = this
            myHttp.selectHomePage({
                groupId:this.groupId,
                type:'2'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.HomePage
                    if(data){
                        var list = JSON.parse(data.numerical)
                        that.list0 = that.filterModult(that.list0,list,0)
                        that.list1 = that.filterModult(that.list1,list,1)
                        that.list2 = that.filterModult(that.list2,list,2)
                        that.list3 = that.filterModult(that.list3,list,3)
                        that.list4 = that.filterModult(that.list4,list,4)
                        that.moduleExeit = true
                        //重新赋值
                        for(var i=0;i<list.length;i++){
                            for(var j=0;j<list[i].length;j++){
                                for(var k=0;k<that.allList.length;k++){
                                    if(list[i][j].index==that.allList[k].index){
                                        that.allList[k].margin =  list[i][j].margin
                                        that.allList[k].show =  list[i][j].show
                                        that.allList[k].border =  list[i][j].border
                                    }
                                }
                            }
                        }
                        
                    }
                }
            })
        },
        //对新模块进行兼容
        filterModult(list,all,col){
            for(var i=0;i<all.length;i++){
                for(var j=0;j<all[i].length;j++){
                    for(var k=0;k<list.length;k++){
                        if(list[k].index==all[i][j].index){
                            list[k].isExit =true
                        }
                    }
                }
            }
            for(var i=0;i<list.length;i++){
                if(!list[i].isExit){
                    all[col].push(list[i])
                }
            }
            return all[col]
        },
        //获取监控视频token
        getMonitorToken(){
            var that = this
            myHttp.getYsToken({
              projectId: this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.ysToken = resp.data.data.accessToken||''
                }
            })
        },
        /*********************************************************************获取劳务数据**************************************************** */
        //获取人员数据
        getPersonNum(){
            var that = this
            myHttp.statisticsPeople({
                entId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    data.bilv = data.zaiZhiCount==0||data.zaiChangCount==0?0:(parseInt(data.zaiChangCount)/parseInt(data.zaiZhiCount)*100).toFixed(1)
                    that.person = data
                }
                if(that.pageTimer["fun1"]){
                    window.clearTimeout(that.pageTimer["fun1"])
                }
                that.pageTimer["fun1"] = setTimeout(that.getPersonNum,that.timeEnt)
            })
        },
        //获取出勤
        getAttend() {
            var that = this
            myHttp.getDayAttendEnt({
                groupId: this.groupId,
                joinType: this.joinType,
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data || {}
                    data.manageRate = data.allTeamsCount && data.allTeamsCount != '0'?( (parseInt(data.manageCount) / parseInt(data.allTeamsCount)) * 100).toFixed(1): 0
                    data.workersRate = data.allTeamsCount && data.allTeamsCount != '0'?( (parseInt(data.workersCount) / parseInt(data.allTeamsCount)) * 100).toFixed(1): 0
                    data.specialRate = data.allTeamsCount && data.allTeamsCount != '0'?( (parseInt(data.specialCount) / parseInt(data.allTeamsCount)) * 100).toFixed(1): 0
                    data.cq = parseInt(data.manageCount)+parseInt(data.workersCount)+parseInt(data.specialCount)
                    data.cqRate = data.allTeamsCount && data.allTeamsCount != '0'? ( (parseInt(data.cq) / parseInt(data.allTeamsCount)) * 100).toFixed(1): 0
                    that.attend = data
                }
                if(that.pageTimer["fun2"]){
                    window.clearTimeout(that.pageTimer["fun2"])
                }
                that.pageTimer["fun2"] = setTimeout(that.getAttend,that.timeEnt)
            })
        },
        //关键岗位
        getKeyPostion() {
            var that = this
            myHttp.selectKeyProjectPerson({
                entId: this.groupId,
                joinType: this.joinType,
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    var obj = {count:0,present:0,attend:0}
                    for(var i=0;i<list.length;i++){
                        obj.count += parseInt(list[i].count) 
                        obj.present += parseInt(list[i].present) 
                        obj.attend += parseInt(list[i].attend) 
                    }
                    that.keyAll = obj
                    that.keyList = list
                }
                if(that.pageTimer["fun3"]){
                    window.clearTimeout(that.pageTimer["fun3"])
                }
                that.pageTimer["fun3"] = setTimeout(that.getKeyPostion,that.timeEnt)
            })
        },
        //获取人员动态(采集人员)
        getCai() {
            var that = this
            myHttp.entPersonDynamic({
                groupId: this.groupId,
                joinType: this.joinType,
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data || {}
                    data.smRate =
                    data.zs && data.zs != '0'
                        ? ((parseInt(data.sm) / parseInt(data.zs)) * 100).toFixed(1) +
                        '%'
                        : '0%'
                    data.zzLv =
                    data.zs && data.zs != '0'
                        ? ((parseInt(data.zz) / parseInt(data.zs)) * 100).toFixed(1) +
                        '%'
                        : '0%'
                    data.wzzLv =
                    data.zs && data.zs != '0'
                        ? ((parseInt(data.wzz) / parseInt(data.zs)) * 100).toFixed(1) +
                        '%'
                        : '0%'
                    data.lzLv =
                    data.zs && data.zs != '0'
                        ? ((parseInt(data.lz) / parseInt(data.zs)) * 100).toFixed(1) +
                        '%'
                        : '0%'
                    that.syn = data
                }
                that.setSynCaht()
                if(that.pageTimer["fun4"]){
                    window.clearTimeout(that.pageTimer["fun4"])
                }
                that.pageTimer["fun4"] = setTimeout(that.getCai,that.timeEnt)
            })
        },
        //获取教育
        edcData() {
            var that = this
            myHttp.entSafetyEducation({
                groupId: this.groupId,
                joinType: this.joinType,
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data
                    data.nopaper = parseInt(data.allNum) - parseInt(data.paperNum)
                    that.edc = data
                }
                that.setExamChart()//考试
                that.setEduChart()//教育
                if(that.pageTimer["fun5"]){
                    window.clearTimeout(that.pageTimer["fun5"])
                }
                that.pageTimer["fun5"] = setTimeout(that.edcData,that.timeEnt)
            })
        },
        //获取合同信息
        getAgreeList(){
            var that = this
            myHttp.findTeamsPerContractByEntId({
                entId:this.groupId,
                joinType:this.joinType
            }).then(function(resp){
                if(resp.data.code=='200'){
                    //agreeNum:{wxq:0,yqht:0,ywq:0,wlv:0,ylv:0},
                    var data = resp.data.data
                    that.agreeNum.yqht = data.yqht||0
                    that.agreeNum.wxq = data.wxq||0
                    that.agreeNum.ywq = data.ywq||0
                    var list = data.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = i
                    }
                    that.tableAgree = list
                    if(that.pageTimer["timer1"]){
                        window.clearInterval(that.pageTimer["timer1"])
                    }
                    that.pageTimer["timer1"] = setInterval(that.scroll1,1800) // 合同滚动
                }
                
            })
        },

        //获取产值进度
        getOutput(){
            var that = this
            myHttp.selectProjectList({
                entId: this.groupId,
                joinType: this.groupType,
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    for (var i = 0; i < list.length; i++) {
                        list[i].pay = list[i].first? JSON.parse(list[i].first):{total0:0,apprMoney:0,list:[],apprlv:0,totalLv:0}
                        var time = ''
                        if(list[i].pay.list.length>0){
                            for(var j=0;j<list[i].pay.list.length;j++){
                                if(time==''){
                                    time = list[i].pay.list[j].time
                                    list[i].pay.apprMoney = list[i].pay.list[j].apprMoney
                                }else if(new Date(time).getTime()<new Date(list[i].pay.list[j].time).getTime()){
                                    time = list[i].pay.list[j].time
                                    list[i].pay.apprMoney = list[i].pay.list[j].apprMoney
                                }
                            }
                        }
                        list[i].index = i
                        list[i].pay.apprMoney = list[i].pay.apprMoney||0
                        list[i].pay.apprlv = list[i].pay.apprlv ||0
                        list[i].pay.totalLv = list[i].pay.totalLv||0
                        list[i].pay.apprlv = !list[i].price || list[i].price=='' ||list[i].price==0 ?0: (parseFloat(list[i].pay.apprMoney)/parseFloat(list[i].price)*100).toFixed(2)
                        list[i].pay.totalLv = !list[i].price || list[i].price=='' ||list[i].price==0 ?0: (parseFloat(list[i].pay.total0)/parseFloat(list[i].price)*100).toFixed(2)
                    }
                    that.progressList = list
                    if(that.pageTimer["timer1"]){
                        window.clearInterval(that.pageTimer["timer1"])
                    }
                    that.pageTimer["timer2"] = setInterval(that.scroll2,3000) // 滚动
                }
            })
        },

        //关键节点进度
        getNodeList(){
            var that = this
            myHttp.statisticsNodeList({
                entId: this.groupId,
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    for(var i=0;i<list.length;i++){
                        list[i].index = i
                    }
                    that.nodeList = list
                    if(that.pageTimer["timer3"]){
                        window.clearInterval(that.pageTimer["timer3"])
                    }
                    that.pageTimer["timer3"] = setInterval(that.scroll3,2000) 
                }
            })
        },

        //质量安全-建设端
        getSafeEnt(){
            var that = this
            myHttp.selectQsAllCountByEntId({
                entId:this.groupId,
                joinType:this.joinType
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.setEntSafeChat(data)
                }
                if(that.pageTimer["fun6"]){
                    window.clearTimeout(that.pageTimer["fun6"])
                }
                that.pageTimer["fun6"] = setTimeout(that.getSafeEnt,that.timeEnt)
            })
        },

        //安康码管控系统
        getAnKang(){
            var that = this
            myHttp.anKangCodeByGroupId({
                groupId:this.groupId,
                joinType:this.joinType
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.anKang = data
                    that.setAllAn()
                    that.setMonthAn()
                }
                if(that.pageTimer["fun7"]){
                    window.clearTimeout(that.pageTimer["fun7"])
                }
                that.pageTimer["fun7"] = setTimeout(that.getAnKang,that.timeEnt)
            })
        },

        //获取岗位效能
        getPostEffEnt(){
            var that = this
            myHttp.selectKeyPositions({
                entId:this.groupId,
                joinType:this.joinType
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    var day = new Date().getDate()
                    for(var i=0;i<list.length;i++){
                        list[i].pmMapsBi = (parseInt(list[i].pmMaps)/parseInt(day)*100).toFixed(0)//施工单位项目经理
                        list[i].threeMapsBi = (parseInt(list[i].threeMaps)/parseInt(day)*100).toFixed(0)//监理代表
                        list[i].fourMapsBi = (parseInt(list[i].fourMaps)/parseInt(day)*100).toFixed(0)//总监理工程师
                        list[i].fiveMapsBi = (parseInt(list[i].fiveMaps)/parseInt(day)*100).toFixed(0)//检测负责人
                    }
                    that.postEffPro = list
                    if(that.pageTimer["timer9"]){
                        window.clearInterval(that.pageTimer["timer9"])
                    }
                    that.pageTimer["timer9"] = setInterval(that.scroll9,3000) 
                }
            })
        },

        //获取项目列表和数量
        getProjectNum(){
            var that = this
            myHttp.getListEnterpriseAndJoinType({
                entId: this.groupId,
                joinType: this.joinType,
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    that.proNum = resp.data.data ? resp.data.data : that.proNum
                }
                if(that.pageTimer["fun8"]){
                    window.clearTimeout(that.pageTimer["fun8"])
                }
                that.pageTimer["fun8"] = setTimeout(that.getProjectNum,that.timeEnt)
            })
        },

        //获取项目列表
        getProjectList(){
            var that = this
            myHttp.getProjectListByEntIdAndJoinType({
                entId: this.groupId,
                joinType: this.joinType
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    that.projectList = list
                    if(list.length>0){
                        // that.project.id = list[0].id
                        // that.project.name = list[0].name
                        // that.project.index = 0
                        // that.getSafePro() //项目质量安全
                        // that.getKeyPersonPro()  //项目关键人员人脸考勤
                        // that.getMonitorList() //项目监控
                        // that.getTowerPro() //获取项目塔吊设备
                        // that.getElePro()  //获取项目升降机信息
                        // that.getDustPro()  //获取项目扬尘信息
                        // that.getUnloadPro() //获取项目卸料平台信息
                        //调用循环展示项目的方法
                        that.refreshPro()
                    }
                    that.showMarker(list)
                }
            })
        },
        //定时展示项目
        refreshPro(){
            if(this.project.index && this.project.index!=''){
                var index = parseInt(this.project.index)+1
                var i = parseInt(index % this.projectList.length)
                this.project.id = this.projectList[i].id
                this.project.name = this.projectList[i].name
                this.project.index = i+''
            }else{
                this.project.id = this.projectList[0].id
                this.project.name = this.projectList[0].name
                this.project.index = '0'
            }
            if(this.pageTimer["pro1"]){
                window.clearTimeout(this.pageTimer["pro1"])
            }
            this.getSafePro() //项目质量安全
            if(this.pageTimer["pro2"]){
                window.clearTimeout(this.pageTimer["pro2"])
            }
            this.getKeyPersonPro()  //项目关键人员人脸考勤
            if(this.pageTimer["pro3"]){
                window.clearTimeout(this.pageTimer["pro3"])
            }
            this.getMonitorList() //项目监控
            if(this.pageTimer["pro4"]){
                window.clearTimeout(this.pageTimer["pro4"])
            }
            this.getTowerPro() //获取项目塔吊设备
            if(this.pageTimer["pro5"]){
                window.clearTimeout(this.pageTimer["pro5"])
            }
            this.getElePro()  //获取项目升降机信息
            if(this.pageTimer["pro6"]){
                window.clearTimeout(this.pageTimer["pro6"])
            }
            this.getDustLine()//获取项目扬尘信息
            if(this.pageTimer["pro7"]){
                window.clearTimeout(this.pageTimer["pro7"])
            }
            this.getDustPie()//获取项目扬尘信息
            if(this.pageTimer["pro8"]){
                window.clearTimeout(this.pageTimer["pro8"])
            }
            this.getUnloadPro() //获取项目卸料平台信息

            if(this.pageTimer["fun9"]){
                window.clearTimeout(this.pageTimer["fun9"])
            }
            this.pageTimer["fun9"] = setTimeout(this.refreshPro,this.timePro)
        },
        //根据项目列表展示地图标记
        showMarker(list){
            var points = [];
            var viewPoints = []
            for (var i = 0; i < list.length; i++) {
                if(list[i].gpsPoint&&''!=list[i].gpsPoint){
                    var obj = list[i]
                    var position = list[i].gpsPoint.split(',')
                    obj.position = {lng: position[0], lat: position[1]}
                    obj.typeName = list[i].projectType=='1'?'房建':'市政'
                    
                    if(list[i].allDay){
                        var readDay = parseInt(list[i].allDay) - parseInt(list[i].otherDay) 
                        obj.progress = ((readDay / list[i].allDay) * 100).toFixed(2)
                    }else{
                        obj.progress = 0
                    }

                    if(obj.projectStatus=='2'){
                    obj.url = require('../../assets/image/pro_build.gif')
                    obj.width = 60,
                    obj.height = 60
                    }else if(obj.projectStatus=='3'){
                    obj.url = require('../../assets/image/pro_build.gif')
                    obj.width = 60,
                    obj.height = 60
                    }else if(obj.projectStatus=='4'){
                    obj.url = require('../../assets/image/pro_build.gif')
                    obj.width = 60,
                    obj.height = 60
                    }
                    points.push(obj)
                    viewPoints.push(new BMap.Point(obj.position.lng,obj.position.lat))
                    
                }
            }
            // this.center = points.length>0?points[0].position:this.center
            this.points = points
            if(this.groupId !='1263382107619520513'){
                var that = this
                setTimeout(function(){
                    that.map.setViewport(viewPoints)
                },100)
            }
            //设置z-index
            setTimeout(function(){
                var pointBg = document.getElementsByClassName('BMap_Marker')
                for(var i=0;i<pointBg.length;i++){
                    if(pointBg[i].className=='BMap_Marker'){
                        pointBg[i].parentNode.style.zIndex = 500
                    }
                }
            },1000)
        },

        //获取项目质量安全
        getSafePro(){
            var that = this
            myHttp.selectProjectQsCount({
                projectId:this.project.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.safePro = data
                    that.setProSafeChat(data)
                }
                if(that.pageTimer["pro1"]){
                    window.clearTimeout(that.pageTimer["pro1"])
                }
                that.pageTimer["pro1"] = setTimeout(that.getSafePro,that.timeEnt)
            })
        },

        //获取项目关键人员人脸考勤
        getKeyPersonPro(){
            var that = this
            myHttp.keyPositionsProAttend({
                projectId:this.project.id,
                v:new Date().getTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].facePhoto = list[i].facePhoto &&list[i].facePhoto!=''?base.httpCtx+list[i].facePhoto:require('../../assets/image/zanwutupian.png')
                        list[i].uploadFile = list[i].uploadFile &&list[i].uploadFile!=''?base.httpCtx+list[i].uploadFile:require('../../assets/image/zanwutupian.png')
                    }
                    that.keyPersonPro = list
                }
                if(that.pageTimer["pro2"]){
                    window.clearTimeout(that.pageTimer["pro2"])
                }
                that.pageTimer["pro2"] = setTimeout(that.getKeyPersonPro,that.timeEnt)
            })
        },

        //获取项目现场监控
        getMonitorList(){
            var that = this
            myHttp.getCameraPageListByProjectId({
                projectId:this.project.id,
                pageNum:1,
                pageSize:6
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list||[];
                    for(var i=0;i<list.length;i++){
                        list[i].showUrl = '/monitor/view/one.html?serial='+list[i].serial+'&channel='+list[i].channelNo+'&token='+that.ysToken
                    }
                    that.monitorList = list
                }
                if(that.pageTimer["pro3"]){
                    window.clearTimeout(that.pageTimer["pro3"])
                }
                that.pageTimer["pro3"] = setTimeout(that.getMonitorList,that.timeEnt)
            })
        },

        //获取塔吊安装统计
        getTowerEnt(){
            var that = this
            myHttp.towerListByEntId({
                entId:this.groupId,
                joinType:this.joinType,
                pageNum:1,
                pageSize:10000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].offline = list[i].offline?list[i].offline:0
                    }
                    that.towerEntList = list
                    if(that.pageTimer["timer4"]){
                        window.clearInterval(that.pageTimer["timer4"])
                    }
                    that.pageTimer["timer4"] = setInterval(that.scroll4,that.timeEnt) 
                }
            })
        },

        //获取卸料平台安装统计
        getUnloadEnt(){
            var that = this
            myHttp.equipUnloadListByEntId({
                entId:this.groupId,
                joinType:this.joinType,
                pageNum:1,
                pageSize:10000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    that.unloadEntList = list
                    if(that.pageTimer["timer5"]){
                        window.clearInterval(that.pageTimer["timer5"])
                    }
                    that.pageTimer["timer5"] = setInterval(that.scroll5,that.timeEnt) 
                }
            })
        },

        //获取高支模安装统计
        getHighEnt(){
            var that = this
            myHttp.highModulusListByEntId({
                entId:this.groupId,
                joinType:this.joinType,
                pageNum:1,
                pageSize:10000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    that.highEntList = list
                    if(that.pageTimer["timer6"]){
                        window.clearInterval(that.pageTimer["timer6"])
                    }
                    that.pageTimer["timer6"] = setInterval(that.scroll6,that.timeEnt)
                }
            })
        },

        //获取升降机安装统计
        getEleEnt(){
            var that = this
            myHttp.elevatorListByEntId({
                entId:this.groupId,
                joniType:this.joinType,
                pageNum:1,
                pageSize:10000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    that.eleEntList = list
                    if(that.pageTimer["timer7"]){
                        window.clearInterval(that.pageTimer["timer7"])
                    }
                    that.pageTimer["timer7"] = setInterval(that.scroll7,that.timeEnt)
                }
            })
        },

        //获取混凝土安装统计
        getMixedEnt(){
            var that = this
            myHttp.concreteListByEntId({
                entId:this.groupId,
                joinType:this.joinType,
                pageNum:1,
                pageSize:10000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    that.mixedEntList = list
                    if(that.pageTimer["timer8"]){
                        window.clearInterval(that.pageTimer["timer8"])
                    }
                    that.pageTimer["timer8"] = setInterval(that.scroll8,that.timeEnt)
                }
            })
        },

        //获取设备运行状态  
        getEquipStatus(){
            var that = this
            myHttp.equipmentByEntId({
                entId:this.groupId,
                joinType:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.equipStatusList[0] = data.attendance
                    that.equipStatusList[1] = data.tower
                    that.equipStatusList[2] = data.projectMonitor
                    that.equipStatusList[3] = data.elevator
                    that.equipStatusList[4] = data.highModulus
                    that.equipStatusList[5] = data.equipUnloadPlatform
                    that.equipStatusList[6] = data.nutHost
                    that.equipStatusList[7] = data.concrete
                }
            })
        },

        //获取项目塔吊
        getTowerPro(){
            var that = this
            myHttp.getTowerListByPage({
                projectId:this.project.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.towerList||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].machType=='3'){
                            list[i].online = list[i].connectedStatus && ''!=list[i].connectedStatus?list[i].connectedStatus:'离线'
                        }else{
                            if(list[i].status=='0'){
                                list[i].online = '离线'
                            }else if(list[i].status=='1'){
                                list[i].online = '在线'
                            }else{
                               list[i].online = '异常'
                            }
                        }
                        
                    }
                    that.towerlist = list
                    if(list.length>0 && that.towerId==''){
                        that.towerId = list[0].id
                    }
                    if(that.towerId!=''){
                        that.getRealInfo()
                    }
                }
            })
        },
        //点击塔吊
        changeTower(row){
            this.towerId = row.id
            this.getRealInfo()
        },
        getRealInfo(){
            var that = this
            myHttp.getTowerInfoByPage({
                id:this.towerId,
                v:new Date().getTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.tower||{}
                    data.angle = data.angle && ''!=data.angle?data.angle:0
                    that.towerPart = data
                    that.cameraData = data.camera
                    if(data.camera){
                        that.towerVideo = '/monitor/view/one.html?serial='+data.camera.serial+'&channel='+data.camera.channelNo+'&token='+that.ysToken
                    }
                }
                //定时刷新
                if(that.pageTimer["pro4"]){
                    window.clearTimeout(that.pageTimer["pro4"])
                }
                that.pageTimer["pro4"] = setTimeout(that.getRealInfo,that.timeEnt)
            })
        },

        //获取项目升降机
        getElePro(){
            var that = this
            myHttp.getEleListByPage({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.elevatorList||[]
                    if(list.length>0){
                        that.getLiftInfo(list[0].id)
                        that.getLiftNum(list[0].deviceId)
                    }
                }
                //定时刷新
                if(that.pageTimer["pro5"]){
                    window.clearTimeout(that.pageTimer["pro5"])
                }
                that.pageTimer["pro5"] = setTimeout(that.getElePro,that.timeEnt)
                
            })
        },
        getLiftInfo(id){
            var that = this
            myHttp.getEleInfoById({
                id:this.towerId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.elevator||{}
                    data.weightReay = data.weight && data.weightPercent?parseFloat(data.weight)/parseFloat(data.weightPercent)*100:''
                    that.liftPart = data
                }
                
                
            })
        },
        getLiftNum(id){
            var that = this
            myHttp.elevatorWarning({
                projectId:this.project.id,
                deviceId:id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.liftPart.msqm = data.msqm||0
                    that.liftPart.mshm = data.mshm||0
                    that.liftPart.qxyj = data.qxyj||0
                    that.liftPart.zlyj = data.zlyj||0
                    that.liftPart.systemStatusForelockStatus = data.ElevatorLog && data.ElevatorLog.systemStatusForelockStatus?data.ElevatorLog.systemStatusForelockStatus:''
                    that.liftPart.systemStatusBehindlockStatus = data.ElevatorLog && data.ElevatorLog.systemStatusBehindlockStatus?data.ElevatorLog.systemStatusBehindlockStatus:''
                    that.liftPart.systemStatusTilt = data.ElevatorLog && data.ElevatorLog.systemStatusTilt?data.ElevatorLog.systemStatusTilt:''
                    that.liftPart.systemStatusWeight = data.ElevatorLog && data.ElevatorLog.systemStatusWeight?data.ElevatorLog.systemStatusWeight:''
                    
                }
            })
        },

        //获取项目扬尘信息
        // getDustPro(){
        //     this.getDustLine()
        //     this.getDustPie()
        // },
        //扬尘监测 - 24小时
        getDustLine(){
            var that = this
            myHttp.get24HourStatisByProjectId({
                projectId: this.project.id
            }).then(function(resp) {
                var list = resp.data.data.dustList || []
                var pm2 = [],
                    pm10 = [],
                    noise = [],
                    temperature = []
                for (var i = 0; i < list.length; i++) {
                    pm2.push(list[i].pm2 || 0)
                    pm10.push(list[i].pm10 || 0)
                    noise.push(list[i].noise || 0)
                    temperature.push(list[i].temperature || 0)
                }
                that.setDustLine(pm2, pm10, noise, temperature)
                // //定时刷新
                if(that.pageTimer["pro6"]){
                    window.clearTimeout(that.pageTimer["pro6"])
                }
                that.pageTimer["pro6"] = setTimeout(that.getDustLine,that.timeEnt)
            })
        },
        //扬尘监测 - PM2.5监测
        getDustPie(){
            var that = this
            myHttp.getPM2ByProjectId({
                projectId: this.project.id
            }).then(function(resp) {
                var data = resp.data.data.pm25
                var all = parseInt(data.cha) + parseInt(data.you) + parseInt(data.liang)
                data.all = all
                that.setDustPie(data)
                //定时刷新
                if(that.pageTimer["pro7"]){
                    window.clearTimeout(that.pageTimer["pro7"])
                }
                that.pageTimer["pro7"] = setTimeout(that.getDustPie,that.timeEnt)
            })
        },

        //获取项目卸料平台信息
        getUnloadPro(){
            var that = this
            myHttp.equipmentList({
                projectId:this.project.id,
                pageNum:1,
                pageSize:1000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list || []
                    that.unloadList = list
                    if(list.length>0){
                        that.unloadId = list[0].verifyCode
                    }else{
                        that.setUnloadGauge()
                    }
                    that.getUnloadInfo()
                }
                
            })
        },
        getUnloadInfo(){
            var that = this
            myHttp.equipUnloadNewestInformation({
                verifyCode:this.unloadId,
                v:new Date().getTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data||{}
                    data.bias = data.bias && ''!=data.bias?data.bias:0
                    that.unloadInfo = data
                    that.setUnloadGauge(data)
                    //定时刷新
                    if(that.pageTimer["pro8"]){
                        window.clearTimeout(that.pageTimer["pro8"])
                    }
                    that.pageTimer["pro8"] = setTimeout(that.getUnloadInfo,that.timeEnt)
                }
            })
        },

        /*************************************************************************************************************可视化图表展示*********** */
        //人员动态
        setSynCaht(){
            var zz = !this.syn.zz||this.syn.zz == 0?0:this.syn.zz
            var lz = !this.syn.lz||this.syn.lz == 0?0:this.syn.lz
            var wzz = !this.syn.wzz||this.syn.wzz == 0?0:this.syn.wzz
            
            var opiton = {
                tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    z: 2,
                    style: {
                        text: '累计统计 \n\n '+this.syn.zs+'人',
                        x: 100,
                        y: 55,
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        lineWidth:40,
                        fontSize: '6',
                        fontWeight: '400',
                    },
                },
                series: [
                {
                    name: '累计人数',
                    type: 'pie',
                    radius: ['50%', '80%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#228FFE','#F7B61C', '#F45E23', '#238FFE']
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}\n{c}',
                            textStyle: {
                                fontSize: '0',
                                fontWeight: 'bold',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                    },
                    labelLine: {
                        show: false,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: zz, name: '在职' },
                        { value: lz, name: '离职' },
                        { value: wzz, name: '未入职' },
                    ],
                },
                ],
            }
            if(document.getElementById('myChart1')){
                var myChart1 = this.$echarts.init(document.getElementById('myChart1'))
                myChart1.setOption(opiton);
            }
        },
        //考试
        setExamChart(){
            var data = {
                paperNum: this.edc.paperNum || 0,
                nopaper: this.edc.nopaper || 0,
            }
            data.paperNum = data.paperNum == 0 ? 0 : data.paperNum
            data.nopaper = data.wzz == 0 ? 0 : data.nopaper
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                series: [
                    {
                        name: '考试统计',
                        type: 'pie',
                        radius: ['40%', '80%'],
                        hoverAnimation: false,
                        avoidLabelOverlap: false,
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = ['#767AED', '#B6C0DC', '#00FFFF', '#238FFE']
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                formatter: '{b}\n{d}%',
                                textStyle: {
                                    fontSize: '10',
                                    fontWeight: '500',
                                    color:'#ffffff'
                                },
                                emphasis: {
                                    show: true,
                                },
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '100%',
                                fontWeight: 'bold',
                            },
                        },
                        labelLine: {
                            show: true,
                            length:2 ,
                            length2:2,
                        },
                        data: [
                            { value: data.paperNum, name: '已入职考试' },
                            { value: data.nopaper, name: '未入职考试' },
                        ],
                    },
                ],
            }
            if(document.getElementById('exam')){
                var exam = this.$echarts.init(document.getElementById('exam'))
                exam.setOption(option);
            }
            
        },
        //教育
        setEduChart(){
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                series: [
                    {
                        name: '教育统计',
                        type: 'pie',
                        radius: ['40%', '80%'],
                        hoverAnimation: false,
                        avoidLabelOverlap: false,
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = ['#F77E3E', '#B6C0DC', '#00FFFF', '#238FFE']
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        label: {
                            normal: {
                                    show: true,
                                    position: 'outside',
                                    formatter: '{b}\n{d}%',
                                    textStyle: {
                                    fontSize: '10',
                                    fontWeight: '500',
                                },
                                emphasis: {
                                    show: true,
                                },
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '100%',
                                fontWeight: 'bold',
                            },
                        },
                        labelLine: {
                            show: true,
                            length:2 ,
                            length2:2,
                        },
                        data: [
                            { value: 0, name: '未受教育' },
                            { value: 0, name: '已受教育' },
                        ],
                    },
                ],
            }
            if(document.getElementById('teach')){
                var teach = this.$echarts.init(document.getElementById('teach'))
                teach.setOption(option);
            }
            
        },
        //质量安全-建设端
        setEntSafeChat(data){
            data = data?data:{
                allCount: 0,
                disposeCount:0,
                unDisposeCount: 0,
                monthCount: 0,
                monthDisposeCount: 0,
                monthUnDisposeCount: 0,
                weekCount: 0,
                weekDisposeCount: 0,
                weekUnDisposeCount: 0
            }
            var option1 = {
                tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    z: 2,
                    style: {
                        text: '累计检查 \n\n '+data.allCount+'个',
                        x: 100,
                        y: 25,
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        lineWidth:40,
                        fontSize: '6',
                        fontWeight: '400',
                    },
                },
                series: [
                {
                    name: '累计数量',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#9285F7','#D5D6D9', '#F45E23', '#238FFE']
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}\n{c}',
                            textStyle: {
                                fontSize: '0',
                                fontWeight: 'bold',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                    },
                    labelLine: {
                        show: false,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: data.unDisposeCount, name: '问题未处理' },
                        { value: data.disposeCount, name: '问题已处理' },
                    ],
                },
                ],
            }
            if(document.getElementById('safeEnt1')){
                var safe1 = this.$echarts.init(document.getElementById('safeEnt1'))
                safe1.setOption(option1);
            }
            //本月
            var option2 = {
                tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    z: 2,
                    style: {
                        text: '本月检查 \n\n '+data.monthCount+'个',
                        x: 100,
                        y: 25,
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        lineWidth:40,
                        fontSize: '6',
                        fontWeight: '400',
                    },
                },
                series: [
                {
                    name: '累计数量',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#15D2B1','#D5D6D9', '#F45E23', '#238FFE']
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}\n{c}',
                            textStyle: {
                                fontSize: '0',
                                fontWeight: 'bold',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                    },
                    labelLine: {
                        show: false,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: data.monthUnDisposeCount, name: '问题未处理' },
                        { value: data.monthDisposeCount, name: '问题已处理' },
                    ],
                },
                ],
            }
            if(document.getElementById('safeEnt2')){
                var safe2 = this.$echarts.init(document.getElementById('safeEnt2'))
                safe2.setOption(option2);
            }
            
            //本周
            var option3 = {
                tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    z: 2,
                    style: {
                        text: '本周检查 \n\n '+data.weekCount+'个',
                        x: 100,
                        y: 25,
                        textAlign: 'center',
                        fill: '#ffffff',
                        width: 30,
                        height: 30,
                        lineWidth:50,
                        fontSize: '6',
                        fontWeight: '400',
                    },
                },
                series: [
                {
                    name: '累计数量',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    hoverAnimation: false,
                    avoidLabelOverlap: false,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#2299F1','#D5D6D9', '#F45E23', '#238FFE']
                                return colorList[params.dataIndex]
                            },
                        },
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}\n{c}',
                            textStyle: {
                                fontSize: '0',
                                fontWeight: 'bold',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                    },
                    labelLine: {
                        show: false,
                        length:8 ,
                        length2:8,
                    },
                    data: [
                        { value: data.weekUnDisposeCount, name: '问题未处理' },
                        { value: data.weekDisposeCount, name: '问题已处理' },
                    ],
                },
                ],
            }
            if(document.getElementById('safeEnt3')){
                var safe3 = this.$echarts.init(document.getElementById('safeEnt3'))
                safe3.setOption(option3);
            }
            
        },
        //累计统计安康码
        setAllAn(){
            // var data = this.ageBar
            if(document.getElementById('ankang1')){
                HighCharts.chart('ankang1', {
                    chart: {
                        type: 'column',
                        backgroundColor: 'rgba(0,0,0,0)',
                        marginBottom: 10,
                        marginTop:10
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    subtitle: {
                        text: ''
                    },
                    colors:['#0CCF93','#ffffff'],
                    xAxis: {
                        type: 'category',
                        // labels: {
                        //     rotation: -45  // 设置轴标签旋转角度
                        // },
                        title: {
                            align:'high',
                            style:{
                                fontSize:'10'
                            }
                        },
                        lineColor:'#3A85E0',
                        labels:{
                            style:{
                                color:'#000000'
                            }
                        },
                    },
                    yAxis: {
                        title: {
                            text: '',
                            align:'high',
                        },
                        minorGridLineColor:'#000000',
                        minorTickColor:'#3A85E0',
                        gridLineColor:'#000000',
                        lineColor:'#3A85E0',
                        lineWidth:1,
                        labels:{
                            style:{
                                color:'#ffffff'
                            }
                        },
                        maxPadding: 0.2,
                        tickInterval:10
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{point.name}: <b>{point.y:.0f} 人</b>',
                        headerFormat:'{series[0].center[1]}<br/>'
                    },
                    series: [{
                        name: '',
                        borderRadius:'0',
                        maxPointWidth:15,
                        data: [
                            {'color':'#0CCF93','y':parseInt(this.anKang.green1),'name':'正常绿码'},
                            {'color':'#F8DA2A','y':parseInt(this.anKang.yellow1),'name':'异常黄码'},
                            {'color':'#FB2121','y':parseInt(this.anKang.red1),'name':'历史红码'},
                        ],
                    }]
                });
            }
        },
        //本月统计安康码
        setMonthAn(){
            if(document.getElementById('ankang2')){
                HighCharts.chart('ankang2', {
                    chart: {
                        type: 'column',
                        backgroundColor: 'rgba(0,0,0,0)',
                        marginBottom: 10,
                        marginTop:10
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    subtitle: {
                        text: ''
                    },
                    colors:['#0CCF93','#ffffff'],
                    xAxis: {
                        type: 'category',
                        title: {
                            align:'high',
                            style:{
                                fontSize:'10'
                            }
                        },
                        lineColor:'#3A85E0',
                        labels:{
                            style:{
                                color:'#000000'
                            }
                        },
                    },
                    yAxis: {
                        // min: 0,
                        title: {
                            text: '',
                            align:'high',
                        },
                        minorGridLineColor:'#000000',
                        minorTickColor:'#3A85E0',
                        gridLineColor:'#000000',
                        lineColor:'#3A85E0',
                        lineWidth:1,
                        labels:{
                            style:{
                                color:'#ffffff'
                            }
                        },
                        maxPadding: 0.2,
                        tickInterval:10
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{point.name}: <b>{point.y:.0f} 人</b>',
                        headerFormat:'{series[0].center[1]}<br/>'
                    },
                    series: [{
                        name: '',
                        borderRadius:'0',
                        maxPointWidth:15,
                        data: [
                            {'color':'#0CCF93','y':parseInt(this.anKang.green2),'name':'正常绿码'},
                            {'color':'#F8DA2A','y':parseInt(this.anKang.yellow2),'name':'异常黄码'},
                            {'color':'#FB2121','y':parseInt(this.anKang.red2),'name':'历史红码'},
                        ],
                    }]
                });
            }
        },
        //项目质量安全
        setProSafeChat(data){
            var data1 = !data.entPendingCount || data.entPendingCount==''?0:data.entPendingCount
            var data2 = !data.projectProcessedCount || data.projectProcessedCount==''?0:data.projectProcessedCount
            var data3 = !data.projectNoProblemCount || data.projectNoProblemCount==''?0:data.projectNoProblemCount
            var option1 = {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    show:true,
                    type: 'scroll',
                    orient: 'vertical',
                    right: 0,
                    icon:'circle',
                    top: 0,
                    bottom: 0,
                    data: ['待处理','已处理','符合'],
                    textStyle:{
                        color:'#ffffff'
                    },
                },
                series: [
                    {
                        name: '项目检查',
                        type: 'pie',
                        radius: '80%',
                        center: ['40%', '50%'],
                        label: {
                            position: 'inner',
                            formatter:'{d}%',
                            fontSize:'8'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = ['#FF9B52','#4EE6B7', '#1299F3']
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        data: [
                            {name:'待处理',value:parseInt(data1)},
                            {name:'已处理',value:parseInt(data2)},
                            {name:'符合',value:parseInt(data3)},
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
            if(document.getElementById('safe1')){
                var safe1 = this.$echarts.init(document.getElementById('safe1'))
                safe1.setOption(option1)
            }
            
            //公司
            var data4 = !data.entPendingCount || data.entPendingCount==''?0:data.entPendingCount
            var data5 = !data.entProcessedCount || data.entProcessedCount==''?0:data.entProcessedCount
            var data6 = !data.entNoProblemCount || data.entNoProblemCount==''?0:data.entNoProblemCount
            var option2 = {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    show:true,
                    type: 'scroll',
                    orient: 'vertical',
                    icon:'circle',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    data: ['待处理','已处理','符合'],
                    textStyle:{
                        color:'#ffffff'
                    },
                },
                series: [
                    {
                        name: '公司检查',
                        type: 'pie',
                        radius: '80%',
                        center: ['40%', '50%'],
                        label: {
                            position: 'inner',
                            formatter:'{d}%',
                            fontSize:'8'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = ['#70BFED','#F47E86', '#6E38A8']
                                    return colorList[params.dataIndex]
                                },
                            },
                        },
                        data: [
                            {name:'待处理',value:parseInt(data4)},
                            {name:'已处理',value:parseInt(data5)},
                            {name:'符合',value:parseInt(data6)},
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
            if(document.getElementById('safe2')){
                var safe2 = this.$echarts.init(document.getElementById('safe2'))
                safe2.setOption(option2)
            }
            
        },

        //扬尘监测（项目）
        setDustLine(pm2,pm10,noise,temperature){
            pm2 = pm2.length>0?pm2:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            pm10 = pm10.length>0?pm10:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            noise = noise.length>0?noise:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            temperature = temperature.length>0?temperature:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            
            var option = {
                title: {
                    text: ''
                },
                legend: {
                    data: ['PM2.5', 'PM10', '噪音(dB)', '温度(℃)'],
                    textStyle:{
                        color:'#fff',
                        fontSize:'8'
                    },
                    itemWidth :5,
                    itemHeight:5, 
                    right:'5%',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top:'20%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
                        nameTextStyle:{
                            color:'#fff'
                        },
                        axisLine:{
                            lineStyle:{
                                color:'#fff'
                            }
                        }
                    }
                ],
                color: ['#29AC5D', '#FF854E', '#892FD5', '#5473E8'],
                yAxis: [
                    {
                        type: 'value',
                        axisLine:{
                            lineStyle:{
                                color:'#fff'
                            }
                        },
                        name: '',
                    }
                ],
                series: [
                    {
                        name: 'PM2.5',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: pm2
                    },
                    {
                        name: 'PM10',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: pm10
                    },
                    {
                        name: '噪音(dB)',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: noise
                    },
                    {
                        name: '温度(℃)',
                        type: 'line',
                        stack: '总量',
                        areaStyle: {},
                        data: temperature
                    }
                ]
            }
            if(document.getElementById('dust1')){
                var dust1 = this.$echarts.init(document.getElementById('dust1'))
                dust1.setOption(option)
            }
            
        },
        //扬尘监测（项目）
        setDustPie(data){
            data = data?data:{all:0,you:0,liang:0,cha:0}
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                graphic: {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    z: 2,
                    style: {
                        text: data.all+'天',
                        x: 100,
                        y: 100,
                        textAlign: 'center',
                        fill: '#ffffff',
                        height: 30,
                        fontSize: '10',
                        fontWeight: 'bold'
                    }
                },
                legend: {
                    orient: 'vertical',
                    x: 'right',
                    data: ['优', '良', '轻度'],
                    textStyle:{
                        color:'#fff',
                        fontSize:'8',
                    },
                    itemWidth :5,
                    itemHeight:5, 
                },
                series: [
                {
                    name: '环境监测',
                    type: 'pie',
                    radius: ['55%', '75%'],
                    hoverAnimation: false,
                    itemStyle: {
                    normal: {
                        color: function(params) {
                        var colorList = ['#6CA2F4', '#78DD7A', '#C3C423']
                        return colorList[params.dataIndex]
                        }
                    }
                    },
                    avoidLabelOverlap: false,
                    label: {
                    normal: {
                        show: false
                    }
                    },
                    labelLine: {
                    show: false
                    },
                    data: [
                    { value: data.you, name: '优' },
                    { value: data.liang, name: '良' },
                    { value: data.cha, name: '轻度' }
                    ]
                }
                ]
            }
            if(document.getElementById('dust2')){
                var page = this.$echarts.init(document.getElementById('dust2'))
                page.setOption(option)
            }
        },

        /**
         * 卸料平台-表图
         */
        setUnloadGauge(data1){
            if(document.getElementById('unload1')){
                var echart1 = this.$echarts.init(document.getElementById('unload1'))
                echart1.setOption({
                    tooltip: {
                        formatter: '{a} <br/>{b} : {c}%'
                    },
                    series: [
                        {
                            name: '偏置值',
                            type: 'gauge',
                            min: -100,
                            max: 100,
                            radius: '100%',
                            axisLine: {            // 坐标轴线
                                lineStyle: {       // 属性lineStyle控制线条样式
                                    color: [[0.8, '#ACBBFA'], [1, '#617AE5']],
                                    width: 1,
                                    shadowColor: '#fff', //默认透明
                                    shadowBlur: 1
                                }
                            },
                            axisLabel:{
                                fontSize:10,
                            },
                            splitLine: {           // 分隔线
                                length: 1,         // 属性length控制线长
                                lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                    width: 1,
                                    color: '#9198B2',
                                }
                            },
                            detail: {formatter: '{value}',fontSize:'10',offsetCenter:[0,'70%']},
                            data: [{value: 0, name: ''}],
                            pointer: {
                                width: 2,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 5
                            },
                        }
                    ]
                })
                var weight = 0 //当前重量
                // 报警重量
                var alarmWeight = 1000
                var echart3 = this.$echarts.init(document.getElementById('unload3'))
                echart3.setOption({
                    tooltip: {
                        formatter: '{a} <br/>{b} : {c}%'
                    },
                    series: [
                        {
                            name: '报警重量',
                            type: 'gauge',
                            min: 0,
                            max: alarmWeight,
                            radius: '100%',
                            axisLine: {            // 坐标轴线
                                lineStyle: {       // 属性lineStyle控制线条样式
                                    color: [[0.8, '#ACBBFA'], [1, '#617AE5']],
                                    width: 0.5,
                                    shadowColor: '#fff', //默认透明
                                    shadowBlur: 0.5
                                }
                            },
                            axisLabel:{
                                fontSize:10,
                            },
                            splitLine: {           // 分隔线
                                length: 1,         // 属性length控制线长
                                lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                                    width: 1,
                                    color: '#9198B2',
                                }
                            },
                            detail: {formatter: '{value}吨',fontSize:'10',offsetCenter:[0,'70%']},
                            data: [{value: weight, name: ''}],
                            pointer: {
                                width: 2,
                                shadowColor: '#fff', //默认透明
                                shadowBlur: 5
                            },
                        }
                    ]
                })
            }
        },


        /**特殊请求展示**********************************************************************************************特殊请求展示************************* */
        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.BMap = BMap
            //this.map.enableScrollWheelZoom();
            //map.addControl(new BMap.ScaleControl());
            // this.getGpsList()
            this.getProjectList()

            var styleJson = [{
                "featureType": "land",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#ffffff"
                }
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#ffffff"
                }
            }, {
                "featureType": "green",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#ffffff"
                }
            }, {
                "featureType": "building",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "building",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "building",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "subwaystation",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#ffffff"
                }
            }, {
                "featureType": "education",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#ffffff"
                }
            }, {
                "featureType": "medical",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#ffffff"
                }
            }, {
                "featureType": "scenicspots",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "color": "#ffffff"
                }
            }, {
                "featureType": "highway",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 4
                }
            }, {
                "featureType": "highway",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "highway",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "highway",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "arterial",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 2
                }
            }, {
                "featureType": "arterial",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "arterial",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "arterial",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "arterial",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffff"
                }
            }, {
                "featureType": "arterial",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "local",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 1
                }
            }, {
                "featureType": "local",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "local",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "local",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "local",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "local",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "railway",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 1
                }
            }, {
                "featureType": "railway",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "railway",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "subway",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on",
                    "weight": 1
                }
            }, {
                "featureType": "subway",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "subway",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "subway",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "subway",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "subway",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "continent",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "city",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "city",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "city",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "city",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "town",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "town",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "town",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "town",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": {
                    "color": "#ffffffff " //  #12223dff
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "districtlabel",
                "elementType": "labels",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": {
                    "visibility": "on"
                }
            }, {
                "featureType": "road",
                "elementType": "labels",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "district",
                "elementType": "labels",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels.icon",
                "stylers": {
                    "visibility": "off"
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels.text.fill",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "poilabel",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "manmade",
                "elementType": "geometry",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "districtlabel",
                "elementType": "labels.text.stroke",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "entertainment",
                "elementType": "geometry",
                "stylers": {
                    "color": "#ffffffff"
                }
            }, {
                "featureType": "shopping",
                "elementType": "geometry",
                "stylers": {
                    "color": "#ffffffff"
                }
            }];
            var that = this
            setTimeout(function(){
                if(that.groupId =='1263382107619520513'){
                    map.setMapStyle({styleJson:styleJson});
                }
                
            },500)
        },
        mapClickFun(e){
            console.log(e)
        },
        

        /**监听模块移动 */
        log(evt){
            // console.log(evt)
            if(this.pageTimer["fun4"]){
                window.clearTimeout(this.pageTimer["fun4"])
            }
            this.getCai()
            if(this.pageTimer["fun5"]){
                window.clearTimeout(this.pageTimer["fun5"])
            }
            this.edcData()
            if(this.pageTimer["fun6"]){
                window.clearTimeout(this.pageTimer["fun6"])
            }
            this.getSafeEnt()
            if(this.pageTimer["pro1"]){
                window.clearTimeout(this.pageTimer["pro1"])
            }
            this.getSafePro()
            if(this.pageTimer["fun7"]){
                window.clearTimeout(this.pageTimer["fun7"])
            }
            this.getAnKang()
            if(this.pageTimer["pro6"]){
                window.clearTimeout(this.pageTimer["pro6"])
            }
            this.getDustLine()//获取项目扬尘信息
            if(this.pageTimer["pro7"]){
                window.clearTimeout(this.pageTimer["pro7"])
            }
            this.getDustPie()//获取项目扬尘信息
            if(this.pageTimer["pro8"]){
                window.clearTimeout(this.pageTimer["pro8"])
            }
            this.getUnloadPro() //获取项目卸料平台信息
            
            this.saveModultList() //保存模块改变
        },
        
        /**推送 */
        /**
        * socket推送
        */
        initWebsocket(){
            var that = this;
            //判断当前浏览器是否支持WebSocket
            if('WebSocket' in window){
                var url = ''
                if(document.location.protocol=="https:"){
                    url = base.httpsWs+"/websocket/"+this.groupId;//wss地址;
                }else{
                    url = base.httpWs+"/websocket/"+this.groupId;//ws地址;
                }
                // var url=base.httpWs+"/websocket/"+this.groupId;
                that.websocket = new WebSocket(url);
            }
            else{
                alert('Not support websocket')
            }
            //连接发生错误的回调方法
            this.websocket.onerror = function(){
                //setMessageInnerHTML("error");
            };
            //连接成功建立的回调方法
            this.websocket.onopen = function(event){
                console.log('websocket连接成功')
                //$("#serverinfo").hide();
                that.errorFlag = false
                that.timeOutObj=null;
            }
            //接收到消息的回调方法
            this.websocket.onmessage = function(event){
                if(event.data=="连接成功")return;
                var x=JSON.parse(event.data);
                if("1"==x.flag){
                    alert(x.msg);
                    that.closeWebSocket();
                }
                if("2"==x.flag){
                    console.log(x)
                    that.showInOutPerson(x);
                }
            }
            //连接关闭的回调方法
            this.websocket.onclose = function(){
                this.timeOutObj=setTimeout(function(){
                    that.initWebsocket();
                }, 60000);
                // $("#serverinfo").show();
                that.errorFlag = true
            }
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function(){
                that.websocket.close();
            }
        },
        //关闭连接
        closeWebSocket(){
            that.websocket.close();
        },
        
        /**
         * 弹出框操作
         */
        //点击显示
        showDialogFun(){
            this.ctrlVis = true
            this.modularList = JSON.parse(JSON.stringify(this.allList))
        },
        //点击确认
        refreshCtl(){
            var listData = this.modularList
            this.modularList = []
            this.allList = JSON.parse(JSON.stringify(listData))

            for(var i=0;i<this.list0.length;i++){
                for(var k=0;k<listData.length;k++){
                    if(this.list0[i].index==listData[k].index){
                        this.list0[i] = listData[k]
                    }
                }
            }
            var len1 = this.list1.length
            for(var j=0;j<len1;j++){
                for(var k=0;k<listData.length;k++){
                    if(this.list1[j].index==listData[k].index){
                        this.list1[j] = listData[k]
                    }
                }
            }
            var len2 = this.list2.length
            for(var j=0;j<len2;j++){
                for(var k=0;k<listData.length;k++){
                    if(this.list2[j].index==listData[k].index){
                        this.list2[j] = listData[k]
                    }
                }
            }
            var len3 = this.list3.length
            for(var j=0;j<len3;j++){
                for(var k=0;k<listData.length;k++){
                    if(this.list3[j].index==listData[k].index){
                        this.list3[j] = listData[k]
                    }
                }
            }
            var len4 = this.list4.length
            for(var j=0;j<len4;j++){
                for(var k=0;k<listData.length;k++){
                    if(this.list4[j].index==listData[k].index){
                        this.list4[j] = listData[k]
                    }
                }
            }
            this.ctrlVis = false
            //保存修改
            this.saveModultList()
        },

        /**列表滚动 ****************************************************************************************列表滚动************************/
        
        //合同列表滚动
        scroll1(){
            if(this.tableAgree.length>7){
                var that = this
                this.animate1=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.tableAgree.push(this.tableAgree[0]);  // 将数组的第一个元素添加到数组的
                        this.tableAgree.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate1 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1200)
            }else{
                window.clearInterval(that.pageTimer["timer1"])
            }
        },

        //产值进度明细      progressList
        scroll2(){
            if(this.progressList.length>3){
                var that = this
                this.animate2=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.progressList.push(this.progressList[0]);  // 将数组的第一个元素添加到数组的
                        this.progressList.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate2 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },2500)
            }else{
                window.clearInterval(this.pageTimer["timer2"])
            }
        },

        //关键节点滚动
        scroll3(){
            if(this.nodeList.length>4){
                var that = this
                this.animate3=true;
                setTimeout(()=>{
                        this.nodeList.push(this.nodeList[0]);
                        this.nodeList.shift(); 
                        this.animate3 = false;
                },1500)
            }else{
                if(this.pageTimer["timer3"]){
                    window.clearInterval(this.pageTimer["timer3"])
                }
            }
        },
        //塔吊安装统计
        scroll4(){
            if(this.towerEntList.length>4){
                var that = this
                this.animate4=true;
                setTimeout(()=>{
                        this.towerEntList.push(this.towerEntList[0]);
                        this.towerEntList.shift(); 
                        this.animate4 = false;
                },1600)
            }else{
                if(this.pageTimer["timer4"]){
                    window.clearInterval(this.pageTimer["timer4"])
                }
            }
        },
        //卸料平台安装统计
        scroll5(){
            if(this.unloadEntList.length>4){
                var that = this
                this.animate5=true;
                setTimeout(()=>{
                        this.unloadEntList.push(this.unloadEntList[0]);
                        this.unloadEntList.shift(); 
                        this.animate5 = false;
                },1600)
            }else{
                if(this.pageTimer["timer5"]){
                    window.clearInterval(this.pageTimer["timer5"])
                }
            }
        },
        //高支模安装统计
        scroll6(){
            if(this.highEntList.length>4){
                var that = this
                this.animate6=true;
                setTimeout(()=>{
                        this.highEntList.push(this.highEntList[0]);
                        this.highEntList.shift(); 
                        this.animate6 = false;
                },1800)
            }else{
                if(this.pageTimer["timer6"]){
                    window.clearInterval(this.pageTimer["timer6"])
                }
            }
        },
        //升降机安装统计
        scroll7(){
            if(this.eleEntList.length>4){
                var that = this
                this.animate7=true;
                setTimeout(()=>{
                        this.eleEntList.push(this.eleEntList[0]);
                        this.eleEntList.shift(); 
                        this.animate7 = false;
                },1800)
            }else{
                if(this.pageTimer["timer7"]){
                    window.clearInterval(this.pageTimer["timer7"])
                }
            }
        },
        //混凝土安装统计
        scroll8(){
            if(this.mixedEntList.length>4){
                var that = this
                this.animate8=true;
                setTimeout(()=>{
                        this.mixedEntList.push(this.mixedEntList[0]);
                        this.mixedEntList.shift(); 
                        this.animate8 = false;
                },1800)
            }else{
                if(this.pageTimer["timer8"]){
                    window.clearInterval(this.pageTimer["timer8"])
                }
            }
        },

        //岗位效能
        scroll9(){
            if(this.postEffPro.length>3){
                var that = this
                this.animate9=true;
                setTimeout(()=>{
                        this.postEffPro.push(this.postEffPro[0]);
                        this.postEffPro.shift(); 
                        this.animate9 = false;
                },2500)
            }else{
                if(this.pageTimer["timer9"]){
                    window.clearInterval(this.pageTimer["timer9"])
                }
            }
        },

        /**
         * 
         */
        _formatRate(value){
            return () => {
                return value + '%'
            }
        },
        
        /**
         * 保存模块
         */
        saveModultList(){
            var that = this
            var data = []
            data.push(this.list0)
            data.push(this.list1)
            data.push(this.list2)
            data.push(this.list3)
            data.push(this.list4)
            console.log(data)
            if(this.moduleExeit){//修改
                myHttp.updateHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(data),
                    type:'2'
                }).then(function(resp){
                    if(resp.data.code=='200'){

                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }else{  //添加
                myHttp.postHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(data),
                    type:'2'
                }).then(function(resp){
                    if(resp.data.code=='200'){

                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }
        },

        /**
         * 返回
         */
        goBack(){
            this.$router.go(-1)
        },

    },
    destroyed(){
        for(var each in this.pageTimer){
            window.clearTimeout(this.pageTimer[each]);
        }
    },
}
</script>

<style scoped>
    *{
        color: #fff;
        font-size: 18rem;
    }
    .big-box{
        width: 7680rem;
        height:4320rem;
        position: relative;
        padding: 40rem 160rem;
        background: url('../../assets/image/visual/screen.jpg');
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
        overflow: hidden;
    }
    /* left0 */
    .list-group-box1{
        width: 846rem;
        height: 3920rem;
        position: relative;
        /* padding: 0 0 0 30rem; */
        padding: 0;
        margin-left: 30rem;
    }
    /* .item-01{
        width: 800rem;
        height: 2935rem;
        position: relative;
        border: 1rem solid #ddd;
        margin: 0 50rem;
    } */
    .item-title{
        /* width: 550rem; */
        width: 68.75%;
        /* height: 10%; */
        height: 64rem;
        min-height: 50rem;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        margin: 0 auto;
        background: url('../../assets/image/visual/txt1.png');
        color: #34ECFF;
        font-size: 24rem;
    }
    .item-div{
        width: 100%;
        height: auto;
        /* margin-top: 180rem; */
        position: relative;
    }

    /* .item-02{
        width: 1360rem;
        height: 2055rem;
        position: relative;
        padding: 0 50rem;
        border:1rem solid red;
        margin-bottom: 100rem;
    } */

    /* .item-03{
        width: 1260rem;
        height: 780rem;
        position: relative;
        padding: 0 10rem 30rem 50rem;
        border: 1rem solid yellow;
        margin: 0 50rem;
    } */

    /* .item-04{
        width: 1060rem;
        height: 456rem;
        position: relative;
        padding: 0 10rem 30rem 10rem;
        border: 1rem solid rgb(28, 209, 22);
        margin: 20rem 50rem;
    } */
    .item-head-p{
        width: 100%;
        height: 60rem;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .item-head-p span{
        width: 14%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .item-head-p span.b-line,.device-item .b-line{
        border-bottom: 2rem solid rgb(112 197 255 / 0.2);
    }
    .item1-con{
        width: 100%;
        /* height: 25vh; */
        position: relative;
        padding: 0 30rem;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
    }
    .device-item{
        width: 100%;
        height: 70rem;
        position: relative;
        display: flex;
    }
    .device-item p,.device-item1 p{
        width: 14%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .device-item1{
        width: 100%;
        height: 80rem;
        position: relative;
        display: flex;
    }
    .item-span{
        position: absolute;
        width: 100%;
        height: 100%;
        left: -1rem;
        top: 2rem;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }

    .item-05{
        /* width: 1260rem; */
        width: 1060rem;
        height: 322rem;
        position: relative;
        padding: 0 10rem 30rem 10rem;
        border: 1rem solid rgb(22, 209, 209);
        margin: 20rem 50rem;
    }
    .car-img{
        width: 160rem;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        justify-items: center;
        /* align-content: center;
        align-items: center; */
        align-content: flex-start;
        padding-top: 30rem;
    }
    .car-img p{
        width: 100%;
        height: 3rem;
        position: relative;
        text-align: center;
        line-height: 3rem;
    }
    .car-num{
        width: calc( 50% - 160rem );
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: center;
    }
    .car-num p{
        width: 100%;
        height: 60rem;
        position: relative;
        display: flex;
        justify-content: flex-start;
        justify-items: flex-start;
        align-content: center;
        align-items: center;
        padding-left: 10rem;
    }

    .item-06{
        width: 1060rem;
        height: 820rem;
        position: relative;
        padding: 0 10rem 30rem 10rem;
        border: 1rem solid rgb(14, 87, 245);
        margin: 20rem 50rem;
    }
    .num-box{
        width: 100%;
        height: 100rem;
        position: relative;
        padding:0 10rem;
        display: flex;
        margin: 30rem 0;
    }
    .num-box-item{
        width: 25%;
        height: 100%;
        padding: 10rem 20rem;
        position: relative;
        cursor: pointer;
    }
    .num-box-item .txt{
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        padding: 10rem 0;
        font-size: 18rem;
    }
    .table-li{
        width: 100%;
        height: 40rem;
        position: relative;
        display: flex;
    }
    .table-li p{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    /* 塔吊 */
    .main-left-item{
        height: 120rem;
        width: 100%;
        position: relative;
        /* background: #E7F1FB; */
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding: 5rem;
        cursor: pointer;
        margin-top: 10rem;
    }
    .main-left-item p{
        height: 40rem;
        position: relative;
        text-align: left;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .main-left-item .name{
        width: 114rem;
        position: relative;
    }
    .main-left-item .state{
        width: 40rem;
        position: relative;
        justify-content: flex-end;
    }
    .main-left-item .num{
        width: 100%;
        position: relative;
    }
    .real-data-l-item{
        width:100%;
        display:flex;
        height:60rem;
        align-items: flex-end;
        /* transform: scale(0.8); */
    }
    .real-data-l-item span{
        display: inline-block;
        /* width: 10vw; */
        margin-left: 16rem;
        height: 40rem;
        display: flex;
        align-content: center;
        align-items: center;
        width: 50%;
    }
    .real-data-l-item .abr{
        position: absolute;
        bottom: 20rem;
        left: 60%;
        width: 70rem;
        height: 30rem;
        font-size: 16rem;
        text-align: center;
        color: #707070;
        background: #c5c1c1;
        background: url(../../assets/image/box.png) no-repeat;
        background-size: 100% 100%;
    }
    .real-clock{
        width: 33%;
        height: 100%;
        position: relative;
        padding: 10rem;
    }
    #wrap.real-clock-con{
        margin-top: 30rem;
        width: 350rem;
        height: 350rem;
    }
    /* 监控************** */
    .monitorbox-item{
        width:33.33%;
        height: 50%;
        position: relative;
        padding: 0 5rem 10rem;
    }
    .item-monitor{
        width: 100%;
        height: calc( 100% - 60rem );
        position: relative;
        /* background: #fff; */
    }
    .item-info{
        width: 100%;
        height: 50rem;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        /* background: #fff; */
    }
    .item-info .name{
        flex:1;
        text-align: center;
        
    }
    .item-info img{
        width:30rem;
        height: auto;
        position: relative;
        margin: 0 20rem;
    }
    .disabled{
        color:#409EFF;
        cursor: pointer;
    }



    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        /* width: 860rem;
        height: 2935rem; */
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        /* background: url('../../assets/image/visual/left1.png'); */
        background-size: 100% 100%;
        justify-content: center;
        align-content: flex-start;
        align-items: flex-start;
        padding: 0 20rem;
    }
    .list-group-item {
        cursor: move;
        display: inline-block;
        position: relative;
        width: 100%;
        /* max-width: 1260rem;
        min-width: 800rem; */
    }
    /* .list-group-item i {
        cursor: pointer;
    } */
    .crile{
        width: 16rem;
        height: 16rem;
        position: relative;
        border-radius: 50%;
        background: #34ECFF;
        margin-right: 20rem;
        display: inline-block;
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .borderCss{
        background: rgba(13, 25, 57, 0.45);
        border: 2rem solid #707070;
    }

    .anim{
        transition: all 1s;
        margin-top: -80rem;
    }
    .anim1{
        transition: all 1s;
        margin-top: -80rem;
    }
    .anim2{
        transition: all 2s;
        margin-top: -300rem;
    }
    .anim3{
        transition: all 1s;
        margin-top: -100rem;
    }
    .anim4{
        transition: all 1s;
        margin-top: -80rem;
    }
    .anim9{
        transition: all 2s;
        margin-top: -270rem;
    }
    /* .anim2{
        transition: all 1s;
        margin-top: -70rem;
    }
    .anim3{
        transition: all 4s;
        margin-top: -200rem;
    } */
</style>

<style>
    @import '../../assets/css/common.css';
    @import '../../assets/css/clock1.css';
    .big-box .el-progress__text{
        color: #fff;
    }

    .big-box .el-input--suffix .el-input__inner{
        background: transparent;
        border: 0;
        color: #fff;
        width: 100rem;
    }
    .big-box .el-select-dropdown__item span{
        color: #000;
    }
    .big-box .hunlin .el-input--suffix .el-input__inner{
        border: 1rem solid #6DBEEA;
        width: 200rem;
    }
    .big-box .list-group-box1 .el-pagination{
        background: rgba(19, 145, 218, 0.2);
        border: 1rem solid #1391DA;
    }
    .big-box .list-group-box1 .el-pagination__total{
        color: #fff;
    }
    .big-box .el-progress-bar{
        padding-right: 70rem;
        margin-right: -70rem;
    }
    .bigVitalDia{
        /* background: rgb(0 0 0 / 0.5); */
        background: rgba(11, 37, 104, 0.45);
        border: 2rem solid #707070;
    }
    .bigVitalDia *{
        color:#34ECFF;
    }
    .bigVitalDia .el-input__inner{
        background: transparent;
        border: 1rem solid #34ECFF;
        height: 80rem;
    }
    .bigVitalDia .el-button{
        border: 1rem solid #34ECFF;
        background: #0B2568;
        color: #fff;
    }
    .big-box *{
        color: #fff;
        font-size: 18rem;
    }
    .big-box .el-pagination{
        padding: 0px !important;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        justify-items: center;
        height: 100%;
    }
    .big-box .el-pagination .btn-next, 
    .big-box .el-pagination .btn-prev{
        background: transparent;
    }
    .big-box .el-pager li{
        padding: 0 4rem;
        font-size: 13rem;
        min-width: 35.5rem;
        height: 28rem;
        line-height: 28rem;
        box-sizing: border-box;
        text-align: center;
    }
    .big-box .el-pagination__editor.el-input .el-input__inner{
        height: 28rem;
    }
    .big-box .el-progress-circle{
        width: 150rem !important;
        height:150rem !important;
    }
    .big-box .el-progress-bar__outer{
        height: 20rem !important;
    }
    .big-box .el-progress__text{
        font-size: 20rem !important;
    }
    #wrap .num180{
        position: absolute;
        top: 150rem;
        right: 62rem;
        margin: 0;
        padding: 0;
        height: 200rem;
        color: #206ED4;
    }
    #wrap ul li {
        position: absolute;
        width: 2rem;
        height: 6rem;
        /* background: #000; */
        background: #fff;
        left: 164rem;
        top: 8rem;
        -webkit-transform-origin: center 158rem;
    }
    .icon {
        position: absolute;
        z-index: 2;
        width: 20rem;
        height: 20rem;
        /* background: #000; */
        background: #fff;
        border-radius: 50%;
        left: 156rem;
        top: 160rem;
    }
    #clockLine {
        position: absolute;
        width: 4rem;
        height: 126rem;
        background: #999;
        left: 164rem;
        top: 40rem;
        -webkit-transform-origin: bottom;
        -webkit-transform: rotate(0deg);
    }
    #wrap .num0 {
        position: absolute;
        top: 20rem;
        left: 154rem;
        margin: 0;
        padding: 0;
        height: 200rem;
        color: #206ED4;
    }
    #wrap ul li:nth-of-type(5n + 1) {
        height: 20rem;
    }
    #wrap .num90 {
        position: absolute;
        top: 140rem;
        right: 30rem;
        margin: 0;
        padding: 0;
        height: 200rem;
        color: #206ED4;
    }
    #wrap .num180 {
        position: absolute;
        top: 250rem;
        right: 125rem;
        margin: 0;
        padding: 0;
        height: 200rem;
        color: #206ED4;
    }
    #wrap .num180 {
        position: absolute;
        top: 250rem;
        right: 125rem;
        margin: 0;
        padding: 0;
        height: 200rem;
        color: #206ED4;
    }
    html{
        font-size:0.25px;
    }
</style>